/*
 * AUTO-GENERATED FILE — DO NOT EDIT MANUALLY.
 *
 * This file is generated by `generate-api-methods.mjs` from `src/api/generated.ts` (OpenAPI).
 *
 */

import { pdel, pget, ppatch, ppost, pput } from "./index";
export const getCampaignCards = pget("/{platformId}/campaign-cards");
export const createCampaignCard = ppost("/{platformId}/campaign-cards");

export const deleteCampaignCard = pdel("/{platformId}/campaign-cards/{campaignCardId}");
export const getCampaignCard = pget("/{platformId}/campaign-cards/{campaignCardId}");

export const updateCampaignCardContent = pput(
  "/{platformId}/campaign-cards/{campaignCardId}/content",
);

export const setCampaignCardLinkInBioVisibility = pput(
  "/{platformId}/campaign-cards/{campaignCardId}/link-in-bio-visibility",
);

export const updateCampaignCardLocations = pput(
  "/{platformId}/campaign-cards/{campaignCardId}/locations",
);

export const generateCampaignCards = ppost("/{platformId}/campaign-cards/generate");

export const acknowledgeCampaignCardGeneration = ppost(
  "/{platformId}/campaign-cards/generate/{jobId}/acknowledge",
);

export const getCampaignCardGenerationStatus = pget("/{platformId}/campaign-cards/generate/status");

export const findCampaignCardImage = ppost("/{platformId}/campaign-cards/image-match");

export const updateCampaignCardOrder = pput("/{platformId}/campaign-cards/order");

export const retrieveGiftCardListings = pget("/{platformId}/gift-cards");
export const createGiftCard = ppost("/{platformId}/gift-cards");

export const activateGiftCard = ppatch("/{platformId}/gift-cards/{giftCardListingId}/activate");

export const deactivateGiftCard = ppatch("/{platformId}/gift-cards/{giftCardListingId}/deactivate");

export const updateGiftCardPresentationAttributes = ppatch(
  "/{platformId}/gift-cards/{giftCardListingId}/presentation-attributes",
);

export const removeGiftCardListingScheduledDate = ppatch(
  "/{platformId}/gift-cards/{giftCardListingId}/remove-scheduled-date",
);

export const setGiftCardListingScheduledDate = ppatch(
  "/{platformId}/gift-cards/{giftCardListingId}/set-scheduled-date",
);

export const updateGiftCardItemForGiftCardTransfer = ppatch(
  "/{platformId}/gift-cards/{giftCardTransferItemId}/set-gift-card-item",
);

export const getTotalClaimableBalance = pget("/{platformId}/gift-cards/claimable-balance");

export const retrievePublicGiftCardUrl = pget("/{platformId}/gift-cards/public-url");

export const getAverageGiftCardAmount = pget("/{platformId}/gift-cards/sales/average-amount");

export const getTotalGiftCardSales = pget("/{platformId}/gift-cards/sales/total");

export const setGiftCardListingsPurchasableLocationsForPlatform = ppost(
  "/{platformId}/gift-cards/set-locations",
);

export const setGiftCardListingsPriceIncrementForPlatform = ppost(
  "/{platformId}/gift-cards/set-price-increment",
);

export const setGiftCardListingPriceIncrement = ppost(
  "/{platformId}/gift-cards/set-price-increment/{giftCardListingId}",
);

export const getGiftCardTransferItem = pget("/{platformId}/gift-cards/transfers");

export const redeemGiftCard = ppost(
  "/{platformId}/gift-cards/transfers/{giftCardTransferItemId}/redeem",
);

export const resendGiftCardNotification = ppost(
  "/{platformId}/gift-cards/transfers/{giftCardTransferItemId}/resend",
);

export const updateGiftCardRecipientPhoneNumber = ppatch(
  "/{platformId}/gift-cards/transfers/{giftCardTransferItemId}/update-recipient-phone",
);

export const getGiftCardTransferItemsByShopDisplayOrderId = pget(
  "/{platformId}/gift-cards/transfers/by-order/{orderId}",
);

export const getPurchasedGiftCardTransferItems = pget(
  "/{platformId}/gift-cards/transfers/purchased",
);

export const getLinkInBioSettings = pget("/{platformId}/link-in-bio");

export const getLinkInBioPreview = pget("/{platformId}/link-in-bio/preview");

export const setLinkInBioShortLink = ppost("/{platformId}/link-in-bio/short-link");

export const getLinkInBioStats = pget("/{platformId}/link-in-bio/stats");

export const sendAdminInboxMessage = ppost("/admin-inbox-messages");

export const previewAdminInboxMessageTargeting = ppost("/admin-inbox-messages/preview");

export const getConversationsSummaryForPlatform = pget(
  "/adonis/platform/{platformId}/conversations",
);

export const getAdonisCustomInstructions = pget(
  "/adonis/platform/{platformId}/custom-instructions",
);
export const setCustomInstructions = ppost("/adonis/platform/{platformId}/custom-instructions");

export const getAllAdonisMetricsForPlatform = pget("/adonis/platform/{platformId}/metrics/all");

export const getAdonisSalesMetricsForPlatform = pget("/adonis/platform/{platformId}/metrics/sales");

export const getAdonisTimeSavedMetricsForPlatform = pget(
  "/adonis/platform/{platformId}/metrics/time-saved",
);

export const getAdonisUsageMetricsForPlatform = pget("/adonis/platform/{platformId}/metrics/usage");

export const getAdonisRecommendationHistoryForPlatformUser = pget(
  "/adonis/platform/{platformId}/platform-user/{platformUserId}/recommendations",
);

export const getAdonisRecommendation = pget("/adonis/platform/{platformId}/recommendation/{id}");

export const getAdonisRecommendationHistoryForPlatform = pget(
  "/adonis/platform/{platformId}/recommendations",
);

export const getRecommendedSalesForPlatform = pget(
  "/adonis/platform/{platformId}/recommended-sales",
);

export const getConversationBySessionId = pget(
  "/adonis/platform/{platformId}/session/{sessionId}/conversation",
);

export const getAdonisSessionsForPlatform = pget("/adonis/platform/{platformId}/sessions");

export const getAdonisStarterQuestions = pget("/adonis/platform/{platformId}/starter-questions");
export const setAdonisStarterQuestions = ppost("/adonis/platform/{platformId}/starter-questions");

export const getTopServiceRecommendationsForPlatform = pget(
  "/adonis/platform/{platformId}/top-service-recommendations",
);

export const retrieveStepTimelinesForPlatform = pget(
  "/ageless/{platformId}/activities/step-timelines",
);

export const getActivityFeed = pget("/ageless/{platformId}/analytics/discovery/activity-feed");

export const getAgeBands = pget("/ageless/{platformId}/analytics/discovery/age-bands");

export const getCampaignPerformance = pget(
  "/ageless/{platformId}/analytics/discovery/campaign-performance",
);

export const getConvertedPatients = pget(
  "/ageless/{platformId}/analytics/discovery/converted-patients",
);

export const getFunnelTrend = pget("/ageless/{platformId}/analytics/discovery/funnel-trend");

export const getGenderMix = pget("/ageless/{platformId}/analytics/discovery/gender-mix");

export const getHomeOverview = pget("/ageless/{platformId}/analytics/discovery/home-overview");

export const getIncomeDemographics = pget(
  "/ageless/{platformId}/analytics/discovery/income-demographics",
);

export const getInsights = pget("/ageless/{platformId}/analytics/discovery/insights");

export const getInterests = pget("/ageless/{platformId}/analytics/discovery/interests");

export const getMarketingInsights = pget(
  "/ageless/{platformId}/analytics/discovery/marketing-insights",
);

export const setPatientLifetimeSpend = pput(
  "/ageless/{platformId}/analytics/discovery/patient-lifetime-spend",
);

export const getOverviewReadyToBook = pget(
  "/ageless/{platformId}/analytics/discovery/ready-to-book",
);

export const getSummary = pget("/ageless/{platformId}/analytics/discovery/summary");

export const getTips = pget("/ageless/{platformId}/analytics/discovery/tips");

export const getTopTreatments = pget("/ageless/{platformId}/analytics/discovery/top-treatments");

export const getReferrers = pget("/ageless/{platformId}/analytics/saasleads/referrers");

export const getSources = pget("/ageless/{platformId}/analytics/saasleads/sources");

export const getCampaigns = pget("/ageless/{platformId}/analytics/wellnessjourney/campaigns");

export const agelessClientLeadsBookConsultationForAssessment = ppost(
  "/ageless/{platformId}/assessments/{assessmentId}/book-consultation",
);

export const getPagedAgelessClientLeads = pget("/ageless/{platformId}/client-leads");

export const getLeadCommunications = pget(
  "/ageless/{platformId}/client-leads/{leadId}/communications",
);
export const logLeadCommunication = ppost(
  "/ageless/{platformId}/client-leads/{leadId}/communications",
);

export const getBackground = pget(
  "/ageless/{platformId}/client-leads/{leadId}/enrichment/background",
);

export const getContactsAndProfiles = pget(
  "/ageless/{platformId}/client-leads/{leadId}/enrichment/contacts-and-profiles",
);

export const getFinancialProfile = pget(
  "/ageless/{platformId}/client-leads/{leadId}/enrichment/financial-profile",
);

export const getLeadEnrichmentInterests = pget(
  "/ageless/{platformId}/client-leads/{leadId}/enrichment/interests",
);

export const getOverview = pget("/ageless/{platformId}/client-leads/{leadId}/enrichment/overview");

export const moveLeadToArchived = ppost(
  "/ageless/{platformId}/client-leads/{leadId}/move-to-archived",
);

export const moveLeadToConsultBooked = ppost(
  "/ageless/{platformId}/client-leads/{leadId}/move-to-consult-booked",
);

export const moveLeadToConsultRequested = ppost(
  "/ageless/{platformId}/client-leads/{leadId}/move-to-consult-requested",
);

export const moveLeadToContacted = ppost(
  "/ageless/{platformId}/client-leads/{leadId}/move-to-contacted",
);

export const moveLeadToNurturing = ppost(
  "/ageless/{platformId}/client-leads/{leadId}/move-to-nurturing",
);

export const getLeadNotes = pget("/ageless/{platformId}/client-leads/{leadId}/notes");
export const addLeadNote = ppost("/ageless/{platformId}/client-leads/{leadId}/notes");

export const deleteLeadNote = pdel("/ageless/{platformId}/client-leads/{leadId}/notes/{noteId}");
export const updateLeadNote = pput("/ageless/{platformId}/client-leads/{leadId}/notes/{noteId}");

export const setLeadOwner = ppatch("/ageless/{platformId}/client-leads/{leadId}/owner");

export const getBreakdown = pget("/ageless/{platformId}/client-leads/{leadId}/score/breakdown");

export const getSignals = pget("/ageless/{platformId}/client-leads/{leadId}/score/signals");

export const getLeadScoreSummary = pget(
  "/ageless/{platformId}/client-leads/{leadId}/score/summary",
);

export const getTreatmentsOfInterest = pget(
  "/ageless/{platformId}/client-leads/{leadId}/score/treatments-of-interest",
);

export const getLeadSessions = pget("/ageless/{platformId}/client-leads/{leadId}/sessions");

export const setLeadState = ppatch("/ageless/{platformId}/client-leads/{leadId}/state");

export const getClientLeadsByAgeBand = pget("/ageless/{platformId}/client-leads/age-band");

export const defineLeadFromAssessment = ppost(
  "/ageless/{platformId}/client-leads/define-from-assessment",
);

export const getClientLeadsByGender = pget("/ageless/{platformId}/client-leads/gender");

export const getClientLeadsByImageGenerated = pget(
  "/ageless/{platformId}/client-leads/image-generated",
);

export const getClientLeadsByLeadOwner = pget("/ageless/{platformId}/client-leads/lead-owner");

export const getClientLeadsByLeadQuality = pget("/ageless/{platformId}/client-leads/lead-quality");

export const getClientLeadsByLeadSource = pget("/ageless/{platformId}/client-leads/lead-source");

export const getClientLeadsByPatientConcern = pget(
  "/ageless/{platformId}/client-leads/patient-concerns",
);

export const getSelectableLeadStates = pget("/ageless/{platformId}/client-leads/selectable-states");

export const getClientLeadsByTreatmentRecommended = pget(
  "/ageless/{platformId}/client-leads/treatments-recommended",
);

export const getClientLeadsByWellnessInterest = pget(
  "/ageless/{platformId}/client-leads/wellness-interests",
);

export const markConsultImportBooked = ppost("/ageless/{platformId}/consult-import");

export const previewConsultImport = ppost("/ageless/{platformId}/consult-import/preview");

export const adminEnrichAndScoreLead = ppost(
  "/ageless/{platformId}/enrich-and-score-lead/{assessmentId}",
);

export const getDeploymentChecklistProgress = pget(
  "/ageless/{platformId}/marketing/deployment-checklist",
);

export const markChecklistItemAsIncomplete = pdel(
  "/ageless/{platformId}/marketing/deployment-checklist/items/{itemSlug}/complete",
);
export const markChecklistItemAsCompleted = ppost(
  "/ageless/{platformId}/marketing/deployment-checklist/items/{itemSlug}/complete",
);

export const getAgelessShortLinks = pget("/ageless/{platformId}/marketing/short-links");
export const defineAgelessShortLink = ppost("/ageless/{platformId}/marketing/short-links");

export const sendAgelessLinkToPatient = ppost("/ageless/{platformId}/send-link-to-patient");

export const completeModule = ppost("/ageless/{platformId}/u/modules/{moduleId}/complete");

export const getAgelessUProgress = pget("/ageless/{platformId}/u/progress");

export const setSessionAttendance = ppost(
  "/ageless/{platformId}/u/sessions/{sessionId}/attendance",
);

export const recordSessionBooking = ppost("/ageless/{platformId}/u/sessions/{sessionId}/booking");

export const getAgelessUSessionBookings = pget("/ageless/{platformId}/u/sessions/bookings");

export const initiateAiOutboundCall = ppost("/ageless/{platformId}/wellness-advisor/ai-call");

export const getAiCallingAgentConfiguration = pget(
  "/ageless/{platformId}/wellness-advisor/ai-calling-agent-configuration",
);
export const setAiCallingAgentConfiguration = pput(
  "/ageless/{platformId}/wellness-advisor/ai-calling-agent-configuration",
);

export const getAiCallingConversionRate = pget(
  "/ageless/{platformId}/wellness-advisor/ai-calling/conversion-rate",
);

export const getAiOutboundCallEligibility = pget(
  "/ageless/{platformId}/wellness-advisor/ai-calling/eligibility",
);

export const getAiCallTranscript = pget(
  "/ageless/{platformId}/wellness-advisor/ai-calls/{providerCallId}/transcript",
);

export const agelessWellnessAdvisorBookConsultationForAssessment = ppost(
  "/ageless/{platformId}/wellness-advisor/assessments/{assessmentId}/book-consultation",
);

export const setLeadStatusForAssessment = ppost(
  "/ageless/{platformId}/wellness-advisor/assessments/{assessmentId}/set-lead-status",
);

export const cancelScheduledMessage = ppost(
  "/ageless/{platformId}/wellness-advisor/cancel-scheduled-message",
);

export const lookupCommunicationClientByContact = ppost(
  "/ageless/{platformId}/wellness-advisor/contacts/lookup",
);

export const getConversationHistory = pget(
  "/ageless/{platformId}/wellness-advisor/conversations/{externalClientId}",
);

export const markConversationAsRead = ppatch(
  "/ageless/{platformId}/wellness-advisor/conversations/{externalClientId}/read",
);

export const setConversationStarred = ppatch(
  "/ageless/{platformId}/wellness-advisor/conversations/{externalClientId}/starred",
);

export const assignSupportingEmployee = ppatch(
  "/ageless/{platformId}/wellness-advisor/conversations/{externalClientId}/supporting-employee",
);

export const addInternalNote = ppost("/ageless/{platformId}/wellness-advisor/internal-notes");
export const updateInternalNote = pput("/ageless/{platformId}/wellness-advisor/internal-notes");

export const deleteInternalNote = pdel(
  "/ageless/{platformId}/wellness-advisor/internal-notes/{externalClientId}/{noteId}",
);

export const searchClientLeads = pget("/ageless/{platformId}/wellness-advisor/leads/search");

export const deletePersonCryptoKey = pdel(
  "/ageless/{platformId}/wellness-advisor/persons/{personId}/crypto-key",
);

export const getRestrictedMessagingWords = pget(
  "/ageless/{platformId}/wellness-advisor/restricted-words",
);

export const scheduleEmailMessage = ppost("/ageless/{platformId}/wellness-advisor/schedule-email");

export const scheduleSmsMessage = ppost("/ageless/{platformId}/wellness-advisor/schedule-sms");

export const sendEmailMessage = ppost("/ageless/{platformId}/wellness-advisor/send-email");

export const sendSmsMessage = ppost("/ageless/{platformId}/wellness-advisor/send-sms");

export const suggestMessage = ppost("/ageless/{platformId}/wellness-advisor/suggest-message");

export const getConversationSummaries = pget("/ageless/{platformId}/wellness-advisor/summaries");

export const getUnreadConversationCount = pget(
  "/ageless/{platformId}/wellness-advisor/summaries/unread-count",
);

export const initiateVoiceCall = ppost("/ageless/{platformId}/wellness-advisor/voice/call");

export const generateVoiceToken = ppost("/ageless/{platformId}/wellness-advisor/voice/token");

export const enrollAssessmentInBookingCampaign = ppost(
  "/ageless/agelesscampaign/assessment/{assessmentId}/booking",
);

export const enrollPlatformToAgelessTrialCampaign = ppost(
  "/ageless/agelesscampaign/platform/{platformId}/enroll-trial",
);

export const enrollPlatformToAgelessWaitlistCampaign = ppost(
  "/ageless/agelesscampaign/platform/{platformId}/enroll-waitlist",
);

export const getAssessmentBanks = pget("/ageless/assessment-banks");

export const getAssessmentBankById = pget("/ageless/assessment-banks/{assessmentBankId}");

export const shareAssessmentBankWithPlatform = ppost(
  "/ageless/assessment-banks/{assessmentBankId}/share/platforms/{platformId}",
);

export const unshareAssessmentBankFromPlatform = ppost(
  "/ageless/assessment-banks/{assessmentBankId}/unshare/platforms/{platformId}",
);

export const backfillRecordAssessmentForBank = ppost(
  "/ageless/assessment-banks/assessments/{agelessAssessmentId}/backfill/record",
);

export const backfillActivateAssessmentBankForSubscription = ppost(
  "/ageless/assessment-banks/subscriptions/{agelessSaaSSubscriptionId}/backfill/activate",
);

export const backfillDefineAssessmentBankForSubscription = ppost(
  "/ageless/assessment-banks/subscriptions/{agelessSaaSSubscriptionId}/backfill/define",
);

export const defineAssessmentByAnonymousId = ppost("/ageless/assessments");

export const retrieveAssessmentById = pget("/ageless/assessments/{assessmentId}");

export const acceptTransformationsForAssessment = ppost(
  "/ageless/assessments/{assessmentId}/accept-transformations",
);

export const retrieveAdminAestheticRecommendations = pget(
  "/ageless/assessments/{assessmentId}/admin-aesthetic-recommendations",
);

export const retrieveAdminLashBrowRecommendations = pget(
  "/ageless/assessments/{assessmentId}/admin-lash-brow-recommendations",
);

export const retrieveAdminWellnessRecommendations = pget(
  "/ageless/assessments/{assessmentId}/admin-wellness-recommendations",
);

export const retrieveAestheticRecommendations = pget(
  "/ageless/assessments/{assessmentId}/aesthetic-recommendations",
);

export const setAiRecommendedTreatmentsOptInForAssessment = pput(
  "/ageless/assessments/{assessmentId}/ai-recommended-treatments-opt-in",
);

export const retrieveBeforeAfterHistoryByAssessmentId = pget(
  "/ageless/assessments/{assessmentId}/before-after-history",
);

export const bookConsultation = ppost("/ageless/assessments/{assessmentId}/book-consultation");

export const captureBookingCtaClick = ppost(
  "/ageless/assessments/{assessmentId}/booking-cta-clicked",
);

export const retrieveConcernsAndGoals = pget(
  "/ageless/assessments/{assessmentId}/concerns-and-goals",
);

export const retrieveConsultationStatus = pget(
  "/ageless/assessments/{assessmentId}/consultation-status",
);

export const revokeAssessmentConsumerHealthConsent = pdel(
  "/ageless/assessments/{assessmentId}/consumer-health",
);

export const retrieveContactInformationByAssessmentId = pget(
  "/ageless/assessments/{assessmentId}/contact-info",
);
export const setAssessmentContactInfo = pput("/ageless/assessments/{assessmentId}/contact-info");

export const retrieveAssessmentContentConsentInfo = pget(
  "/ageless/assessments/{assessmentId}/content-consent-info",
);

export const setAssessmentContext = pput("/ageless/assessments/{assessmentId}/context");

export const retrieveAssessmentDetailsById = pget("/ageless/assessments/{assessmentId}/details");

export const retrieveEnrichedLeadInformationByAssessmentId = pget(
  "/ageless/assessments/{assessmentId}/enriched-lead",
);

export const retrieveFutureSelfImageWithTreatments = pget(
  "/ageless/assessments/{assessmentId}/future-photos/with-treatments",
);

export const retrieveFutureSelfImage = pget(
  "/ageless/assessments/{assessmentId}/future-photos/without-treatments",
);

export const retrieveFutureSelfProjectionImagesForAssessment = pget(
  "/ageless/assessments/{assessmentId}/future-self-projection-images",
);

export const generateAssessmentResults = ppost(
  "/ageless/assessments/{assessmentId}/generate-results",
);

export const getAgelessImagingFeedback = pget(
  "/ageless/assessments/{assessmentId}/imaging-feedback",
);
export const submitAgelessImagingFeedback = ppost(
  "/ageless/assessments/{assessmentId}/imaging-feedback",
);

export const getAllAgelessImagingFeedback = pget(
  "/ageless/assessments/{assessmentId}/imaging-feedback/all",
);

export const retrieveAdminLashBrowAnalysis = pget(
  "/ageless/assessments/{assessmentId}/lash-brow-analysis",
);

export const retrieveLashBrowBeforeAfterHistoryByAssessmentId = pget(
  "/ageless/assessments/{assessmentId}/lash-brow-before-after-history",
);

export const markAssessmentResultsViewedByTaker = ppost(
  "/ageless/assessments/{assessmentId}/mark-results-viewed-by-taker",
);

export const linkPersonToAssessment = pput("/ageless/assessments/{assessmentId}/person/{personId}");

export const setAssessmentPhotoDeviceInformation = pput(
  "/ageless/assessments/{assessmentId}/photo-device-info",
);

export const setPlatformForAssessment = pput(
  "/ageless/assessments/{assessmentId}/platform/{platformId}",
);

export const setAssessmentPreScanInformation = pput("/ageless/assessments/{assessmentId}/pre-scan");

export const setPreferredLocationForAssessment = pput(
  "/ageless/assessments/{assessmentId}/preferred-location/{preferredLocationId}",
);

export const retrievePrintableSummaryPdf = pget(
  "/ageless/assessments/{assessmentId}/printable-summary.pdf",
);

export const setProviderNotesForAssessment = pput(
  "/ageless/assessments/{assessmentId}/provider-notes",
);

export const setResultPresentationForAssessment = pput(
  "/ageless/assessments/{assessmentId}/result-presentation",
);

export const sendAssessmentResultsToPerson = ppost(
  "/ageless/assessments/{assessmentId}/send-results",
);

export const setAssessmentStepById = pput("/ageless/assessments/{assessmentId}/step");

export const setAssessmentSelectedTreatments = pput(
  "/ageless/assessments/{assessmentId}/treatments",
);

export const retrieveWellnessGeneratedPhotosForAssessment = pget(
  "/ageless/assessments/{assessmentId}/wellness-generated-photos",
);

export const retrieveWellnessRecommendations = pget(
  "/ageless/assessments/{assessmentId}/wellness-recommendations",
);

export const computeAssessmentImageDiff = ppost("/ageless/assessments/compute-image-diff");

export const retrieveCurrentAssessment = pget("/ageless/assessments/current");

export const retrieveCurrentAssessmentContactPrefill = pget(
  "/ageless/assessments/current/contact-prefill",
);

export const setCurrentAssessmentEmail = pput("/ageless/assessments/current/email");

export const recordCurrentAssessmentExperimentAssignment = pput(
  "/ageless/assessments/current/experiments",
);

export const setCurrentAssessmentOriginalLanguage = pput(
  "/ageless/assessments/current/original-language",
);

export const defineAssessmentForAnonymousPerson = ppost(
  "/ageless/assessments/define-for-anonymous-person",
);

export const generateAfterImage = ppost(
  "/ageless/assessments/generate-after-image/{aiProviderName}",
);

export const retrievePagedAssessmentsForPlatform = pget(
  "/ageless/assessments/platform/{platformId}",
);

export const retrieveJustArrivedAssessmentsForPlatform = pget(
  "/ageless/assessments/platform/{platformId}/just-arrived",
);

export const retrievePagedAssessmentsForPlatformListView = pget(
  "/ageless/assessments/platform/{platformId}/list-view",
);

export const retrievePagedAssessmentsForPersonForPlatformListView = pget(
  "/ageless/assessments/platform/{platformId}/person/{personId}/list-view",
);

export const retrieveRequestedConsultationAssessmentsForPlatform = pget(
  "/ageless/assessments/platform/{platformId}/requested-consultation",
);

export const retrieveWaitingOnPatientAssessmentsForPlatform = pget(
  "/ageless/assessments/platform/{platformId}/waiting-on-patient",
);

export const retrieveV2JustArrivedAssessmentsForPlatform = pget(
  "/ageless/assessments/v2/platform/{platformId}/just-arrived",
);

export const retrieveV2RequestedConsultationAssessmentsForPlatform = pget(
  "/ageless/assessments/v2/platform/{platformId}/requested-consultation",
);

export const retrieveV2WaitingOnPatientAssessmentsForPlatform = pget(
  "/ageless/assessments/v2/platform/{platformId}/waiting-on-patient",
);

export const verifyAssessmentToken = pget("/ageless/assessments/verify");

export const initiatedPhoneNumberVerificationForAssessment = ppost(
  "/ageless/auth/assessments/{assessmentId}/initiate-phone-verification",
);

export const initiatePhoneNumberVerificationForAssessmentResults = ppost(
  "/ageless/auth/assessments/{assessmentId}/initiate-phone-verification-for-results",
);

export const verifyPhoneNumberForAssessment = ppost(
  "/ageless/auth/assessments/{assessmentId}/verify-phone-number",
);

export const verifyPhoneNumberForAssessmentResults = ppost(
  "/ageless/auth/assessments/{assessmentId}/verify-phone-number-for-results",
);

export const grantBillingManagerRoles = ppost(
  "/ageless/billing-manager-backfills/platforms/{platformId}/persons/{personId}",
);

export const getPlatformCapability = pget("/ageless/capabilities/platforms/{platformId}");
export const definePlatformCapability = ppost("/ageless/capabilities/platforms/{platformId}");

export const setClinicalContext = pput(
  "/ageless/capabilities/platforms/{platformId}/clinical-context",
);

export const setConservativeModel = pput(
  "/ageless/capabilities/platforms/{platformId}/conservative-model",
);

export const deselectCapability = pput(
  "/ageless/capabilities/platforms/{platformId}/deselect-capability",
);

export const disableBeautyScoreVisibilityForAgelessPlatformCapability = pput(
  "/ageless/capabilities/platforms/{platformId}/disable-beauty-score-visibility",
);

export const enableBeautyScoreVisibilityForAgelessPlatformCapability = pput(
  "/ageless/capabilities/platforms/{platformId}/enable-beauty-score-visibility",
);

export const setLashBrowClinicalContext = pput(
  "/ageless/capabilities/platforms/{platformId}/lash-brow-clinical-context",
);

export const setPreferredDisplayName = pput(
  "/ageless/capabilities/platforms/{platformId}/preferred-display-name",
);

export const setPricePerUnit = pput("/ageless/capabilities/platforms/{platformId}/price-per-unit");

export const selectCapability = pput(
  "/ageless/capabilities/platforms/{platformId}/select-capability",
);

export const setSelectedCapabilities = pput(
  "/ageless/capabilities/platforms/{platformId}/selected-capabilities",
);

export const applyTaxonomyPricing = pput(
  "/ageless/capabilities/platforms/{platformId}/taxonomy-pricing",
);

export const setTreatmentPlanPriceRange = pput(
  "/ageless/capabilities/platforms/{platformId}/treatment-plan-price-range",
);

export const setWellnessClinicalContext = pput(
  "/ageless/capabilities/platforms/{platformId}/wellness-clinical-context",
);

export const getProductCapabilities = pget("/ageless/capabilities/products");
export const defineProductCapability = ppost("/ageless/capabilities/products");

export const archiveProductCapability = pdel("/ageless/capabilities/products/{id}");

export const setPromptData = pput("/ageless/capabilities/products/{id}/prompt-data");

export const getProductCapabilitiesAdmin = pget("/ageless/capabilities/products/admin");

export const getCreateOptions = pget("/ageless/capabilities/products/create-options");

export const getProductCapabilitiesForPlatform = pget(
  "/ageless/capabilities/products/platform/{platformId}",
);

export const getSelectedCapabilitiesForFlow = pget(
  "/ageless/capabilities/products/platform/{platformId}/flow/{flowType}",
);

export const getSignupProductCapabilities = pget("/ageless/capabilities/products/signup");

export const backfillContactedState = ppost("/ageless/client-lead-backfills/contacted-state");

export const queryCrossPlatformConversationHistory = pget(
  "/ageless/comms/people/{personId}/conversations/query",
);

export const lookupPerson = ppost("/ageless/comms/people/lookup");

export const getPagedAgelessPlatformComms = pget("/ageless/comms/platforms");

export const getAgelessCommsForPlatform = pget("/ageless/comms/platforms/{platformId}");

export const querySentAdminCommsForPlatform = pget(
  "/ageless/comms/platforms/{platformId}/sent-admin-comms/query",
);

export const querySmsMetricCountsForPlatform = pget(
  "/ageless/comms/platforms/{platformId}/sms-metric-counts/query",
);

export const getNearestLocationForPlatformByPostalCode = pget(
  "/ageless/companies/platforms/{platformId}/nearest-location",
);

export const getNearestLocationForPlatformByCoordinates = pget(
  "/ageless/companies/platforms/{platformId}/nearest-location/by-coordinates",
);

export const checkServiceAreaByPostalCode = pget(
  "/ageless/companies/platforms/{platformId}/service-area-check",
);

export const getPracticeFinderLocationsByAddress = pget(
  "/ageless/companies/search/platform-locations/by-address",
);

export const getPracticeFinderLocationsByCoordinates = pget(
  "/ageless/companies/search/platform-locations/by-coordinates",
);

export const getCompanyIdByCrmContactEmail = pget(
  "/ageless/companies/search/platform/{emailToSearch}",
);

export const getPlatformBySubdomain = pget("/ageless/companies/search/platform/by-subdomain");

export const getBookingCtaOfferBySubdomain = pget(
  "/ageless/companies/search/platform/by-subdomain/booking-cta-offer",
);

export const getPlatformLocationsBySubdomain = pget(
  "/ageless/companies/search/platform/by-subdomain/locations",
);

export const getPlatformThemeBySubdomain = pget(
  "/ageless/companies/search/platform/by-subdomain/theme",
);

export const getEnabledAgelessFlowsForPlatform = pget(
  "/ageless/companies/search/platform/enabled-flows",
);

export const getAgelessFlowAccessForPlatform = pget(
  "/ageless/companies/search/platform/flow-access",
);

export const getIsPlatformOnboardedForAgeless = pget(
  "/ageless/companies/search/platform/is-onboarded-for-ageless",
);

export const getAgelessProductOptionsForPlatform = pget(
  "/ageless/companies/search/platform/product-options",
);

export const getActivePlatformsByCrmContactEmail = pget(
  "/ageless/companies/search/platforms/{emailToSearch}/active",
);

export const getPlatformsByApproxLocation = pget("/ageless/companies/search/platforms/by-address");

export const getPlatformsByApproxCoordinates = pget(
  "/ageless/companies/search/platforms/by-coordinates",
);

export const getPracticeFinderRankings = pget(
  "/ageless/companies/search/platforms/practice-finder-rankings",
);

export const getAccessiblePracticesByEmail = pget(
  "/ageless/companies/search/practice/{emailToSearch}",
);

export const getSuggestedSlugs = pget("/ageless/companies/slug-suggestions");

export const regenerateComprehensiveAnalysis = ppost(
  "/ageless/comprehensive-analysis-repairs/{assessmentId}/regenerate",
);

export const captureAssessmentBiometricConsent = ppost(
  "/ageless/consent/assessments/{assessmentId}/biometric",
);

export const captureAssessmentConsumerHealthConsent = ppost(
  "/ageless/consent/assessments/{assessmentId}/consumer-health",
);

export const captureAssessmentMarketingSmsConsent = ppost(
  "/ageless/consent/assessments/{assessmentId}/marketing-sms",
);

export const revokeAssessmentPromotionalMarketingConsent = pdel(
  "/ageless/consent/assessments/{assessmentId}/promotional-marketing",
);
export const captureAssessmentPromotionalMarketingConsent = ppost(
  "/ageless/consent/assessments/{assessmentId}/promotional-marketing",
);

export const revokeBiometricConsent = pdel(
  "/ageless/consent/biometric/persons/{personId}/platforms/{platformId}",
);
export const captureBiometricConsent = ppost(
  "/ageless/consent/biometric/persons/{personId}/platforms/{platformId}",
);

export const deleteBiometricImagesForPerson = pdel(
  "/ageless/consent/biometric/persons/{personId}/platforms/{platformId}/images",
);

export const revokeConsumerHealthConsent = pdel(
  "/ageless/consent/consumer-health/persons/{personId}/platforms/{platformId}",
);
export const captureConsumerHealthConsent = ppost(
  "/ageless/consent/consumer-health/persons/{personId}/platforms/{platformId}",
);

export const getPersonalConsent = pget(
  "/ageless/consent/persons/{personId}/platforms/{platformId}",
);

export const revokePromotionalMarketingConsent = pdel(
  "/ageless/consent/promotional-marketing/persons/{personId}/platforms/{platformId}",
);
export const capturePromotionalMarketingConsent = ppost(
  "/ageless/consent/promotional-marketing/persons/{personId}/platforms/{platformId}",
);

export const setConsultContactInfo = pput("/ageless/consult/{assessmentId}/contact-info");

export const retrieveConsultAssessmentDetails = pget("/ageless/consult/{assessmentId}/details");

export const uploadConsultFrontalFacialImage = ppost(
  "/ageless/consult/{assessmentId}/frontal-facial",
);

export const generateConsultResults = ppost("/ageless/consult/{assessmentId}/generate-results");

export const linkPatientToConsultAssessment = pput("/ageless/consult/{assessmentId}/link-patient");

export const setConsultPhotoCaptureComplete = ppost(
  "/ageless/consult/{assessmentId}/photo-capture-complete",
);

export const textConsultPhotoCaptureLink = ppost(
  "/ageless/consult/{assessmentId}/photo-capture-link/text",
);

export const setConsultPreScanInformation = pput("/ageless/consult/{assessmentId}/pre-scan");

export const uploadConsultProfileFacialImage = ppost(
  "/ageless/consult/{assessmentId}/profile-facial",
);

export const setConsultProviderNotes = pput("/ageless/consult/{assessmentId}/provider-notes");

export const sendConsultResults = ppost("/ageless/consult/{assessmentId}/send-results");

export const setConsultSelectedTreatments = pput("/ageless/consult/{assessmentId}/treatments");

export const uploadConsultWellnessBodyPhoto = ppost(
  "/ageless/consult/{assessmentId}/wellness-body-photo",
);

export const confirmConsultWellnessPhotoCapture = ppost(
  "/ageless/consult/{assessmentId}/wellness-photo-capture/confirm",
);

export const retrieveConsultFrontalFacialImageLashBrowValidation = pget(
  "/ageless/consult/frontal-facial/{imageId}/lash-brow-validation",
);

export const retrieveConsultFrontalFacialImageValidation = pget(
  "/ageless/consult/frontal-facial/{imageId}/validation",
);

export const startConsultSession = ppost("/ageless/consult/sessions");

export const getAddressForCoordinates = pget("/ageless/geocoding/address");

export const getCoordinatesForAddress = pget("/ageless/geocoding/coordinates");

export const getLocationInfoFromPostalCode = pget("/ageless/geocoding/postal-code");

export const getAgelessHostConfiguration = pget("/ageless/host-configuration");

export const getNextImageReviewSubject = pget("/ageless/image-review/queue/next");

export const submitImageReviews = ppost("/ageless/image-review/reviews");

export const getMyImageReviews = pget("/ageless/image-review/reviews/mine");

export const getImageReviewSubject = pget("/ageless/image-review/subjects/{assessmentId}/{kind}");

export const getImageReviewDashboard = pget("/ageless/image-review/supervisor/dashboard");

export const generateImageReviewFeedbackSummary = ppost(
  "/ageless/image-review/supervisor/feedback-summary",
);

export const getLatestImageReviewFeedbackSummary = pget(
  "/ageless/image-review/supervisor/feedback-summary/latest",
);

export const getImageGenerationsForReview = pget("/ageless/image-review/supervisor/generations");

export const getImageReviewModelChanges = pget("/ageless/image-review/supervisor/model-changes");
export const createImageReviewModelChange = ppost("/ageless/image-review/supervisor/model-changes");

export const archiveImageReviewModelChange = pdel(
  "/ageless/image-review/supervisor/model-changes/{modelChangeId}",
);

export const observeImagePromptRevision = ppost(
  "/ageless/image-review/supervisor/prompt-revision/observe",
);

export const getAllImageReviews = pget("/ageless/image-review/supervisor/reviews");

export const getImageReviewSubjectDetail = pget(
  "/ageless/image-review/supervisor/subjects/{assessmentId}/{kind}",
);

export const retrieveComprehensiveTreatmentAnalysis = pget(
  "/ageless/imaging/assessments/{assessmentId}/analysis",
);

export const retrieveComprehensiveLashBrowAnalysis = pget(
  "/ageless/imaging/assessments/{assessmentId}/lash-brow-analysis",
);

export const setAssessmentPhotoCaptureComplete = ppost(
  "/ageless/imaging/assessments/{assessmentId}/photo-capture-complete",
);

export const uploadFrontalFacialImage = ppost(
  "/ageless/imaging/assessments/{assessmentId}/platforms/{platformId}/frontal-facial",
);

export const uploadLashBrowEyeCrop = ppost(
  "/ageless/imaging/assessments/{assessmentId}/platforms/{platformId}/frontal-facial/{frontalFacialImageId}/lash-brow-eye-crop",
);

export const uploadProfileFacialImage = ppost(
  "/ageless/imaging/assessments/{assessmentId}/platforms/{platformId}/profile-facial",
);

export const uploadWellnessBodyPhoto = ppost(
  "/ageless/imaging/assessments/{assessmentId}/platforms/{platformId}/wellness-body-photo",
);

export const confirmWellnessPhotoCapture = ppost(
  "/ageless/imaging/assessments/{assessmentId}/wellness-photo-capture/confirm",
);

export const declineWellnessForAssessment = ppost(
  "/ageless/imaging/assessments/{assessmentId}/wellness/decline",
);

export const retrieveFrontalFacialImage = pget("/ageless/imaging/frontal-facial/{imageId}");

export const retrieveFrontalFacialImageLashBrowValidation = pget(
  "/ageless/imaging/frontal-facial/{imageId}/lash-brow-validation",
);

export const validateFrontalFacialImage = ppost(
  "/ageless/imaging/frontal-facial/{imageId}/validate",
);

export const retrieveFrontalFacialImageValidation = pget(
  "/ageless/imaging/frontal-facial/{imageId}/validation",
);

export const validateProfileFacialImage = ppost(
  "/ageless/imaging/profile-facial/{imageId}/validate",
);

export const retrieveProfileFacialImageValidation = pget(
  "/ageless/imaging/profile-facial/{imageId}/validation",
);

export const retrieveWellnessBodyPhotoValidation = pget(
  "/ageless/imaging/wellness-body-photo/{photoId}/validation",
);

export const defineAgelessInactivePlatformInterest = ppost("/ageless/inactive-platform-interests");

export const externalIntegrationGetAfterImageSample = pget(
  "/ageless/integrations/external/{provider}/after-images/sample",
);

export const getAfterImageSampleForProviderV2 = pget(
  "/ageless/integrations/external/{provider}/after-images/sample/v2",
);

export const testAuth = pget("/ageless/integrations/external/{provider}/auth/test");

export const externalIntegrationGetBookingRequestSample = pget(
  "/ageless/integrations/external/{provider}/booking-requests/sample",
);

export const getBookingRequestSampleForProviderV2 = pget(
  "/ageless/integrations/external/{provider}/booking-requests/sample/v2",
);

export const updateClientStatus = ppost("/ageless/integrations/external/{provider}/client-status");

export const createHook = ppost("/ageless/integrations/external/{provider}/hooks");

export const deleteHook = pdel("/ageless/integrations/external/{provider}/hooks/{id}");

export const unhook = ppost("/ageless/integrations/external/{provider}/hooks/unhook");

export const externalIntegrationGetLashBrowImageSample = pget(
  "/ageless/integrations/external/{provider}/lash-brow-images/sample",
);

export const getLashBrowImageSampleForProviderV2 = pget(
  "/ageless/integrations/external/{provider}/lash-brow-images/sample/v2",
);

export const externalIntegrationGetContactSample = pget(
  "/ageless/integrations/external/{provider}/patient-contacts/sample",
);

export const getContactSampleForProviderV2 = pget(
  "/ageless/integrations/external/{provider}/patient-contacts/sample/v2",
);

export const externalIntegrationGetWellnessImageSample = pget(
  "/ageless/integrations/external/{provider}/wellness-images/sample",
);

export const getWellnessImageSampleForProviderV2 = pget(
  "/ageless/integrations/external/{provider}/wellness-images/sample/v2",
);

export const getProductOption = pget("/ageless/leads/product-options/{platformId}");
export const setProductOption = pput("/ageless/leads/product-options/{platformId}");

export const disableAgelessLeads = ppost("/ageless/leads/product-options/{platformId}/disable");

export const enableAgelessLeads = ppost("/ageless/leads/product-options/{platformId}/enable");

export const getAgelessMarketingContext = pget("/ageless/marketing/platforms/{platformId}/context");

export const getAgelessShortLinkCatalog = pget(
  "/ageless/marketing/platforms/{platformId}/short-links/catalog",
);

export const getSharedWebsiteEmbedSettings = pget(
  "/ageless/marketing/platforms/{platformId}/website-embed-settings",
);

export const getSetupLinkScope = pget("/ageless/marketing/setup-link");

export const getSetupLinkDeploymentChecklistProgress = pget(
  "/ageless/marketing/setup-link/deployment-checklist",
);

export const markSetupLinkChecklistItemAsCompleted = pput(
  "/ageless/marketing/setup-link/deployment-checklist/items/{itemSlug}/complete",
);

export const markSetupLinkChecklistItemAsIncomplete = pput(
  "/ageless/marketing/setup-link/deployment-checklist/items/{itemSlug}/incomplete",
);

export const defineSetupLinkAgelessShortLink = ppost("/ageless/marketing/setup-link/short-links");

export const setSetupLinkWebsiteEmbedAllowedOrigins = pput(
  "/ageless/marketing/setup-link/website-embed/allowed-origins",
);

export const resolveAgelessShortLink = pget("/ageless/marketing/short-links/resolve");

export const getCancellations = pget("/ageless/metrics/cancellations");

export const getCancellationsCsv = pget("/ageless/metrics/cancellations/csv");

export const getCancellationsXlsx = pget("/ageless/metrics/cancellations/xlsx");

export const disableAgelessOutboundPhoneCallsForPlatform = ppost(
  "/ageless/notification-campaigns/ageless-outbound-phone-calls/platform/{platformId}/disable",
);

export const enableAgelessOutboundPhoneCallsForPlatform = ppost(
  "/ageless/notification-campaigns/ageless-outbound-phone-calls/platform/{platformId}/enable",
);

export const disableAutomatedOutreachForAssessment = ppost(
  "/ageless/notification-campaigns/automated-outreach/{assessmentId}/disable",
);

export const enableAutomatedOutreachForAssessment = ppost(
  "/ageless/notification-campaigns/automated-outreach/{assessmentId}/enable",
);

export const getAutomatedOutreachEnabledForPlatform = pget(
  "/ageless/notification-campaigns/automated-outreach/platform/{platformId}",
);

export const disableAutomatedOutreachForPlatform = ppost(
  "/ageless/notification-campaigns/automated-outreach/platform/{platformId}/disable",
);

export const enableAutomatedOutreachForPlatform = ppost(
  "/ageless/notification-campaigns/automated-outreach/platform/{platformId}/enable",
);

export const getReduceOutreachFrequencyStatus = pget(
  "/ageless/notification-campaigns/reduce-outreach-frequency/platform/{platformId}",
);

export const disableReduceOutreachFrequencyForPlatform = ppost(
  "/ageless/notification-campaigns/reduce-outreach-frequency/platform/{platformId}/disable",
);

export const enableReduceOutreachFrequencyForPlatform = ppost(
  "/ageless/notification-campaigns/reduce-outreach-frequency/platform/{platformId}/enable",
);

export const resendResultsForAssessment = ppost(
  "/ageless/notification-campaigns/resend-results/{assessmentId}",
);

export const startDunningEnforcementSaga = ppost(
  "/ageless/notification-sagas/dunning-enforcement/subscriptions/{agelessSaaSSubscriptionId}/start",
);

export const backfillPlatformOnboardingCompletion = ppost(
  "/ageless/notification-sagas/platform/{platformId}/onboarding-completion/backfill",
);

export const startPersonPlatformNotificationsForPlatformStaff = ppost(
  "/ageless/notification-sagas/platform/{platformId}/staff/start",
);

export const startPlatformNotification = ppost(
  "/ageless/notification-sagas/platform/{platformId}/start",
);

export const backfillPlatformCancellation = ppost(
  "/ageless/notification-sagas/subscriptions/{agelessSaaSSubscriptionId}/cancellation/backfill",
);

export const backfillCancellationCancelRequestedDate = pput(
  "/ageless/notification-sagas/subscriptions/{agelessSaaSSubscriptionId}/cancellation/cancel-requested-date",
);

export const backfillWebsiteEmbedAssessmentContextForAllEmbedEnabledPlatforms = ppost(
  "/ageless/notification-sagas/website-embed-assessment-context/backfill-all",
);

export const setDomain = pput("/ageless/onboarding/{platformId}/domain");

export const getFreePrintsStatus = pget("/ageless/onboarding/{platformId}/free-prints-status");

export const unlockFreePrintsForPlatformForOnboarding = ppost(
  "/ageless/onboarding/{platformId}/free-prints/unlock",
);

export const getLocations = pget("/ageless/onboarding/{platformId}/locations");
export const createLocation = ppost("/ageless/onboarding/{platformId}/locations");

export const setLocationAddress = pput(
  "/ageless/onboarding/{platformId}/locations/{locationId}/address",
);

export const setLocationBookingUrl = pput(
  "/ageless/onboarding/{platformId}/locations/{locationId}/booking-url",
);

export const setLocationName = pput("/ageless/onboarding/{platformId}/locations/{locationId}/name");

export const setLocationOperatingHours = pput(
  "/ageless/onboarding/{platformId}/locations/{locationId}/operating-hours",
);

export const setLocationPhoneNumber = pput(
  "/ageless/onboarding/{platformId}/locations/{locationId}/phone-number",
);

export const getNotificationPhoneNumber = pget(
  "/ageless/onboarding/{platformId}/notification-phone-number",
);
export const setNotificationPhoneNumber = pput(
  "/ageless/onboarding/{platformId}/notification-phone-number",
);

export const getProgress = pget("/ageless/onboarding/{platformId}/progress");
export const setStepCompleted = ppost("/ageless/onboarding/{platformId}/progress");

export const getServiceArea = pget("/ageless/onboarding/{platformId}/service-area");
export const saveServiceArea = pput("/ageless/onboarding/{platformId}/service-area");

export const getWaitlistEntry = pget("/ageless/onboarding/{platformId}/waitlist");

export const agelessPartnerBookConsultationBookConsultationForAssessment = ppost(
  "/ageless/partner/assessments/{assessmentId}/book-consultation",
);

export const getLatestSignedImageUrls = pget("/ageless/partner/assessments/{assessmentId}/images");

export const getAssessmentInsights = pget("/ageless/partner/assessments/{assessmentId}/insights");

export const getStoredSuggestedBillingPlanForPlatform = pget(
  "/ageless/partner/platforms/{platformId}/stored-suggested-billing-plan",
);

export const getStoredSuggestedBillingPlanForSubscription = pget(
  "/ageless/partner/platforms/{platformId}/subscriptions/{subscriptionId}/stored-suggested-billing-plan",
);

export const suggestPotentialBillingPlanForPartner = pget(
  "/ageless/partner/platforms/{platformId}/suggest-potential-billing-plan",
);

export const getAchievementsProgress = pget("/ageless/platforms/{platformId}/achievements");

export const getAchievementAcknowledgements = pget(
  "/ageless/platforms/{platformId}/achievements/acknowledgements",
);
export const acknowledgeAchievementUnlocks = pput(
  "/ageless/platforms/{platformId}/achievements/acknowledgements",
);

export const getPaybackValue = pget(
  "/ageless/platforms/{platformId}/settings/billing/payback-value",
);

export const getState = pget("/ageless/platforms/{platformId}/settings/billing/state");

export const getSubscriptions = pget(
  "/ageless/platforms/{platformId}/settings/billing/subscriptions",
);

export const getAvailablePlans = pget(
  "/ageless/platforms/{platformId}/settings/billing/subscriptions/{subscriptionId}/available-plans",
);

export const cancelBillingSubscription = pput(
  "/ageless/platforms/{platformId}/settings/billing/subscriptions/{subscriptionId}/cancel",
);

export const getCancellationReasons = pget(
  "/ageless/platforms/{platformId}/settings/billing/subscriptions/{subscriptionId}/cancel-reasons",
);

export const requestBillingSubscriptionCancellation = pput(
  "/ageless/platforms/{platformId}/settings/billing/subscriptions/{subscriptionId}/cancellation-request",
);

export const rescindBillingSubscriptionCancellation = pput(
  "/ageless/platforms/{platformId}/settings/billing/subscriptions/{subscriptionId}/cancellation-request/rescind",
);

export const recordBillingSubscriptionCancellationIntent = ppost(
  "/ageless/platforms/{platformId}/settings/billing/subscriptions/{subscriptionId}/cancellation-requests",
);

export const saveBillingSubscriptionCancellation = ppost(
  "/ageless/platforms/{platformId}/settings/billing/subscriptions/{subscriptionId}/cancellation-save",
);

export const initiateBillingPaymentMethodUpdateLink = ppost(
  "/ageless/platforms/{platformId}/settings/billing/subscriptions/{subscriptionId}/payment-method-update-link",
);

export const switchBillingPlan = pput(
  "/ageless/platforms/{platformId}/settings/billing/subscriptions/{subscriptionId}/plan",
);

export const rescindBillingSubscriptionPendingPlanSwitch = pput(
  "/ageless/platforms/{platformId}/settings/billing/subscriptions/{subscriptionId}/plan-switch-request/rescind",
);

export const getStoredSuggestedBillingPlan = pget(
  "/ageless/platforms/{platformId}/settings/billing/subscriptions/{subscriptionId}/stored-suggested-billing-plan",
);

export const setBillingSubscriptionTrialEnd = pput(
  "/ageless/platforms/{platformId}/settings/billing/subscriptions/{subscriptionId}/trial-end",
);

export const suggestPotentialBillingPlan = pget(
  "/ageless/platforms/{platformId}/settings/billing/suggest-potential-billing-plan",
);

export const getTransactionLedger = pget(
  "/ageless/platforms/{platformId}/settings/billing/transaction-ledger",
);

export const getTransactions = pget(
  "/ageless/platforms/{platformId}/settings/billing/transactions",
);

export const getUsageThreshold = pget(
  "/ageless/platforms/{platformId}/settings/billing/usage-threshold",
);
export const setUsageThreshold = pput(
  "/ageless/platforms/{platformId}/settings/billing/usage-threshold",
);

export const getAiAutoReplySettings = pget(
  "/ageless/platforms/features/{platformId}/ai-auto-reply",
);

export const disableAiAutoReply = pput(
  "/ageless/platforms/features/{platformId}/ai-auto-reply/disable",
);

export const enableAiAutoReply = pput(
  "/ageless/platforms/features/{platformId}/ai-auto-reply/enable",
);

export const setBeautyScoreDisplayName = pput(
  "/ageless/platforms/features/{platformId}/beauty-score-display-name",
);

export const generateMarketingSetupLink = ppost(
  "/ageless/platforms/features/{platformId}/marketing/setup-link",
);

export const getWebsiteEmbedSettings = pget(
  "/ageless/platforms/features/{platformId}/website-embed-settings",
);

export const setWebsiteEmbedAllowedOrigins = pput(
  "/ageless/platforms/features/{platformId}/website-embed/allowed-origins",
);

export const disableWebsiteEmbed = pput(
  "/ageless/platforms/features/{platformId}/website-embed/disable",
);

export const enableWebsiteEmbed = pput(
  "/ageless/platforms/features/{platformId}/website-embed/enable",
);

export const sendWebsiteEmbedInstructions = ppost(
  "/ageless/platforms/features/{platformId}/website-embed/send-instructions",
);

export const getAssessmentOutreachSettings = pget(
  "/ageless/platforms/sync/{platformId}/assessments/{assessmentId}/outreach-settings",
);

export const getOutreachSettings = pget("/ageless/platforms/sync/{platformId}/outreach-settings");

export const mirrorRepeatMdPermissionsForAgelessPlatformPerson = ppost(
  "/ageless/platforms/sync/{platformId}/people/{personId}/permissions/mirror-repeatmd",
);

export const refreshAgelessExternalAudienceForPlatform = ppost(
  "/ageless/platforms/sync/{platformId}/refresh-audience",
);

export const refreshAgelessExternalAudienceMilestonesForPlatform = ppost(
  "/ageless/platforms/sync/{platformId}/refresh-audience-milestones",
);

export const defineAssessment = ppost("/ageless/poc/assessments");

export const getAssessment = pget("/ageless/poc/assessments/{assessmentId}");

export const getSelectableCapabilities = pget(
  "/ageless/poc/assessments/{assessmentId}/capabilities",
);

export const captureModularBiometricConsent = ppost(
  "/ageless/poc/assessments/{assessmentId}/consent/biometric",
);

export const captureModularConsumerHealthConsent = ppost(
  "/ageless/poc/assessments/{assessmentId}/consent/consumer-health",
);

export const captureModularPromotionalMarketingConsent = ppost(
  "/ageless/poc/assessments/{assessmentId}/consent/promotional-marketing",
);

export const captureModularSmsConsent = ppost(
  "/ageless/poc/assessments/{assessmentId}/consent/sms",
);

export const captureModularTransactionalConsent = ppost(
  "/ageless/poc/assessments/{assessmentId}/consent/transactional",
);

export const requestAnalysisGeneration = ppost(
  "/ageless/poc/assessments/{assessmentId}/generations/analysis",
);

export const requestEnhancedImageGeneration = ppost(
  "/ageless/poc/assessments/{assessmentId}/generations/enhanced-image",
);

export const requestFutureSelfGeneration = ppost(
  "/ageless/poc/assessments/{assessmentId}/generations/future-self",
);

export const modularAssessmentsPocUploadImage = ppost(
  "/ageless/poc/assessments/{assessmentId}/images/{imageRole}",
);

export const initiatePhoneVerification = ppost(
  "/ageless/poc/assessments/{assessmentId}/initiate-phone-verification",
);

export const setIntakeAnswer = pput(
  "/ageless/poc/assessments/{assessmentId}/intake-answers/{questionId}",
);

export const initiateResumePhoneVerification = ppost(
  "/ageless/poc/assessments/{assessmentId}/resume/initiate-phone-verification",
);

export const verifyResumePhone = ppost(
  "/ageless/poc/assessments/{assessmentId}/resume/verify-phone",
);

export const getTreatmentPlan = pget("/ageless/poc/assessments/{assessmentId}/treatment-plan");

export const addPlanTreatment = ppost(
  "/ageless/poc/assessments/{assessmentId}/treatment-plan/treatments",
);

export const removePlanTreatment = pdel(
  "/ageless/poc/assessments/{assessmentId}/treatment-plan/treatments/{capabilityId}",
);

export const verifyPhone = ppost("/ageless/poc/assessments/{assessmentId}/verify-phone");

export const getDomainDefinitions = pget("/ageless/poc/domains");

export const recordAgelessPracticeFinderAssessmentClick = ppost(
  "/ageless/practice-finder/assessment-clicks",
);

export const recordAgelessPracticeFinderPageView = ppost("/ageless/practice-finder/page-views");

export const recordAgelessPracticeFinderSearch = ppost("/ageless/practice-finder/searches");

export const getAgelessProductPlans = pget("/ageless/product-plans");

export const getAgelessDepositLineItems = pget("/ageless/product-plans/deposit-line-items");

export const purchaseFoundersClubOffSession = ppost(
  "/ageless/purchase-saas-product/{agelessSaaSLeadId}/founders-club/charge",
);

export const defineAgelessLeadsDepositIntentForSaaSLead = ppost(
  "/ageless/purchase-saas-product/deposit-intent",
);

export const retrieveAgelessLeadsDepositIntentById = pget(
  "/ageless/purchase-saas-product/deposit-intent/{depositIntentId}",
);

export const removeFoundersClubLineItemFromDepositIntent = pdel(
  "/ageless/purchase-saas-product/deposit-intent/{depositIntentId}/founders-club",
);
export const addFoundersClubLineItemToDepositIntent = ppost(
  "/ageless/purchase-saas-product/deposit-intent/{depositIntentId}/founders-club",
);

export const handleStripeWebhook = ppost("/ageless/purchase-saas-product/webhooks/stripe/{region}");

export const getPagedAgelessSaaSLeads = pget("/ageless/saas-leads");

export const setAddressOnAgelessSaaSLead = pput("/ageless/saas-leads/{agelessSaaSLeadId}/address");

export const defineSubscriptionForAgelessSaaSLead = ppost(
  "/ageless/saas-leads/{agelessSaaSLeadId}/define-subscription",
);

export const getDefineSubscriptionStripeTrialPreview = pget(
  "/ageless/saas-leads/{agelessSaaSLeadId}/define-subscription/stripe-trial-preview",
);

export const setDesiredStartDateOnAgelessSaaSLead = pput(
  "/ageless/saas-leads/{agelessSaaSLeadId}/desired-start-date",
);

export const getAgelessSaaSLeadDetails = pget("/ageless/saas-leads/{agelessSaaSLeadId}/details");

export const setEmailOnAgelessSaaSLeadForAdmin = pput(
  "/ageless/saas-leads/{agelessSaaSLeadId}/email",
);

export const getLinkedPlatformsForAgelessSaaSLead = pget(
  "/ageless/saas-leads/{agelessSaaSLeadId}/linked-platforms",
);

export const setPartnershipForAgelessSaaSLead = pput(
  "/ageless/saas-leads/{agelessSaaSLeadId}/partnership",
);

export const getPotentialAdminEmailMatchesForAgelessSaaSLead = pget(
  "/ageless/saas-leads/{agelessSaaSLeadId}/potential-admin-email-matches",
);

export const getPotentialPatientPhoneMatchesForAgelessSaaSLead = pget(
  "/ageless/saas-leads/{agelessSaaSLeadId}/potential-patient-phone-matches",
);

export const setRecurringBillingProfileOnAgelessSaaSLead = pput(
  "/ageless/saas-leads/{agelessSaaSLeadId}/recurring-billing-profile",
);

export const clearAgelessSaaSCustomPlanTermsFromLead = pdel(
  "/ageless/saas-leads/{agelessSaaSLeadId}/saas-custom-plan-terms",
);

export const getAgelessSaaSSubscriptions = pget(
  "/ageless/saas-leads/{agelessSaaSLeadId}/subscriptions",
);

export const retrieveWaitlistSummary = pget("/ageless/saas-leads/{agelessSaaSLeadId}/waitlist");

export const setAccountExecutiveIdOnAgelessSaaSLead = pput(
  "/ageless/saas-leads/account-executive-id",
);

export const setBusinessType = pput("/ageless/saas-leads/business-type");

export const setDisqualificationReason = pput("/ageless/saas-leads/disqualification-reason");

export const setEmailOnAgelessSaaSLead = pput("/ageless/saas-leads/email");

export const initiateEmailVerification = ppost("/ageless/saas-leads/email-verification/initiate");

export const verifyEmailAddress = ppost("/ageless/saas-leads/email-verification/verify");

export const setExistingRepeatMdPlatformIdOnAgelessSaaSLead = pput(
  "/ageless/saas-leads/existing-repeatmd-platform",
);

export const defineAgelessSaaSLead = ppost("/ageless/saas-leads/full");

export const setGoldCastEventIdOnAgelessSaaSLead = pput("/ageless/saas-leads/goldcast-event-id");

export const setGooglePlaceDetailsOnAgelessSaaSLead = pput(
  "/ageless/saas-leads/google-place-details",
);

export const reserveGroupSessionSpotByEmail = ppost("/ageless/saas-leads/group-session-spot");

export const setInitiatedEnterpriseDemoRequest = pput(
  "/ageless/saas-leads/initiated-enterprise-demo-request",
);

export const setLikelyEnterpriseCustomer = pput("/ageless/saas-leads/likely-enterprise-customer");

export const setLocationCount = pput("/ageless/saas-leads/location-count");

export const setMonthlyPatientVolume = pput("/ageless/saas-leads/monthly-patient-volume");

export const setUnverifiedPhoneNumber = pput("/ageless/saas-leads/phone");

export const setVerifiedPhoneNumber = pput("/ageless/saas-leads/phone/verified");

export const setPracticeInformationOnAgelessSaaSLead = pput(
  "/ageless/saas-leads/practice-information",
);

export const setAgelessSaaSCustomPlanTermsOnLead = pput(
  "/ageless/saas-leads/saas-custom-plan-terms",
);

export const setSalesforceOpportunityOnAgelessSaaSLead = pput(
  "/ageless/saas-leads/salesforce-opportunity",
);

export const getAgelessSaaSLeadsSummary = pget("/ageless/saas-leads/summary");

export const setInitialTreatmentListForAgelessSaaSLead = pput("/ageless/saas-leads/treatments");

export const retrieveWaitlistToken = ppost("/ageless/saas-leads/waitlist/token");

export const getPagedAgelessSaaSSubscriptions = pget("/ageless/saas-subscriptions");

export const getAgelessSaaSSubscription = pget(
  "/ageless/saas-subscriptions/{agelessSaaSSubscriptionId}",
);

export const activateAgelessSaaSSubscription = pput(
  "/ageless/saas-subscriptions/{agelessSaaSSubscriptionId}/activate",
);

export const cancelAgelessSaaSSubscription = pput(
  "/ageless/saas-subscriptions/{agelessSaaSSubscriptionId}/cancel",
);

export const getAgelessSaaSSubscriptionEvents = pget(
  "/ageless/saas-subscriptions/{agelessSaaSSubscriptionId}/events",
);

export const recordBillableAssessmentOverageForAgelessSaaSSubscription = ppost(
  "/ageless/saas-subscriptions/{agelessSaaSSubscriptionId}/metered-usage/assessment-overage",
);

export const markAgelessSaaSSubscriptionPastDue = pput(
  "/ageless/saas-subscriptions/{agelessSaaSSubscriptionId}/past-due",
);

export const initiateAgelessSaaSSubscriptionPaymentMethodUpdateLink = ppost(
  "/ageless/saas-subscriptions/{agelessSaaSSubscriptionId}/payment-method-update-link",
);

export const syncAgelessSaaSSubscriptionPaymentMethodUpdate = ppost(
  "/ageless/saas-subscriptions/{agelessSaaSSubscriptionId}/payment-method-update-sync",
);

export const setAgelessSaaSSubscriptionPlan = pput(
  "/ageless/saas-subscriptions/{agelessSaaSSubscriptionId}/plan",
);

export const transferAgelessSaaSSubscriptionToPlatform = pput(
  "/ageless/saas-subscriptions/{agelessSaaSSubscriptionId}/platform/{platformId}",
);

export const rescindAgelessSaaSSubscriptionCancellation = pput(
  "/ageless/saas-subscriptions/{agelessSaaSSubscriptionId}/rescind-cancel",
);

export const getSubscriptionScopedTransactionLedger = pget(
  "/ageless/saas-subscriptions/{agelessSaaSSubscriptionId}/transaction-ledger",
);

export const resendSaaSInvoiceReceiptForAgelessSaaSSubscription = ppost(
  "/ageless/saas-subscriptions/{agelessSaaSSubscriptionId}/transaction-ledger/{ledgerEntryId}/resend-receipt",
);

export const setAgelessSaaSSubscriptionTrialEnd = pput(
  "/ageless/saas-subscriptions/{agelessSaaSSubscriptionId}/trial-end",
);

export const setAgelessSaaSSubscriptionTrialStart = pput(
  "/ageless/saas-subscriptions/{agelessSaaSSubscriptionId}/trial-start",
);

export const markAgelessSaaSSubscriptionTrialing = pput(
  "/ageless/saas-subscriptions/{agelessSaaSSubscriptionId}/trialing",
);

export const markAgelessSaaSSubscriptionUnpaid = pput(
  "/ageless/saas-subscriptions/{agelessSaaSSubscriptionId}/unpaid",
);

export const getPagedAgelessSaaSSubscriptionConversionDays = pget(
  "/ageless/saas-subscriptions/conversion-days",
);

export const getPagedAgelessSaaSSubscriptionConversionDayDetails = pget(
  "/ageless/saas-subscriptions/conversion-days/{conversionDate}/details",
);

export const getAgelessSaaSSubscriptionConversionDayDetailsCsv = pget(
  "/ageless/saas-subscriptions/conversion-days/{conversionDate}/details/csv",
);

export const getAgelessSaaSSubscriptionConversionDaysCsv = pget(
  "/ageless/saas-subscriptions/conversion-days/csv",
);

export const getAgelessSaaSSubscriptionsCsv = pget("/ageless/saas-subscriptions/csv");

export const getAgelessSaaSSubscriptionsByPlatform = pget(
  "/ageless/saas-subscriptions/platforms/{platformId}",
);

export const getAgelessSaaSSubscriptionsSummary = pget("/ageless/saas-subscriptions/summary");

export const sendTrialEndAdminNotificationsForPlatform = ppost(
  "/ageless/saas-subscriptions/trial-end/admin-notifications",
);

export const runStartupSeeds = ppost("/ageless/seed/run-startup-seeds");

export const seedAssessmentJourney = ppost("/ageless/seed/seed-journey");

export const generateShortLivedAssessmentToken = ppost(
  "/ageless/short-lived/assessments/{assessmentId}/short-lived-token",
);

export const retrieveAssessmentByToken = pget("/ageless/short-lived/assessments/by-token");

export const generateShareToken = ppost("/ageless/short-lived/assessments/share-token");

export const generateWebsiteEmbedToken = ppost(
  "/ageless/short-lived/platforms/{platformId}/website-embed-token",
);

export const validateWebsiteEmbedToken = pget(
  "/ageless/short-lived/platforms/website-embed-token/validate",
);

export const simulateInboundEmail = ppost(
  "/ageless/test/agentic-reply-scenarios/platforms/{platformId}/inbound-email",
);

export const simulateInboundSms = ppost(
  "/ageless/test/agentic-reply-scenarios/platforms/{platformId}/inbound-sms",
);

export const getAgenticReplyTurn = pget(
  "/ageless/test/agentic-reply-scenarios/platforms/{platformId}/turns/{inboundMessageId}",
);

export const definePersonForAssessment = ppost("/ageless/test/define-person/{assessmentId}");

export const activateSubscription = ppost(
  "/ageless/test/dunning-scenarios/platforms/{platformId}/activate",
);

export const cancelTrial = ppost(
  "/ageless/test/dunning-scenarios/platforms/{platformId}/cancel-trial",
);

export const applyCancelled = ppost(
  "/ageless/test/dunning-scenarios/platforms/{platformId}/cancelled",
);

export const applyDashboardLocked = ppost(
  "/ageless/test/dunning-scenarios/platforms/{platformId}/dashboard-locked",
);

export const dispatchPlanSuggestion = ppost(
  "/ageless/test/dunning-scenarios/platforms/{platformId}/dispatch-plan-suggestion",
);

export const applyLeadsSuspended = ppost(
  "/ageless/test/dunning-scenarios/platforms/{platformId}/leads-suspended",
);

export const applyPastDue = ppost(
  "/ageless/test/dunning-scenarios/platforms/{platformId}/past-due",
);

export const getDunningScenarioStatus = pget(
  "/ageless/test/dunning-scenarios/platforms/{platformId}/status",
);

export const enrichAndScoreLead = ppost("/ageless/test/enrich-and-score-lead/{assessmentId}");

export const enrollBookingCampaign = ppost("/ageless/test/enroll-booking-campaign/{assessmentId}");

export const admitFromWaitlist = ppost(
  "/ageless/test/onboarding-scenarios/platforms/{platformId}/admit",
);

export const completeOnboarding = ppost(
  "/ageless/test/onboarding-scenarios/platforms/{platformId}/onboarding/complete",
);

export const completeOnboardingStep = ppost(
  "/ageless/test/onboarding-scenarios/platforms/{platformId}/onboarding/steps/{step}",
);

export const getOnboardingScenarioStatus = pget(
  "/ageless/test/onboarding-scenarios/platforms/{platformId}/status",
);

export const getOnboardingScenarioStatuses = pget(
  "/ageless/test/onboarding-scenarios/platforms/statuses",
);

export const lockAgelessDashboardForDunningTest = ppost(
  "/ageless/test/platforms/{platformId}/dunning/lock-dashboard",
);

export const resumeAgelessLeadDeliveryForDunningTest = ppost(
  "/ageless/test/platforms/{platformId}/dunning/resume-lead-delivery",
);

export const suspendAgelessLeadDeliveryForDunningTest = ppost(
  "/ageless/test/platforms/{platformId}/dunning/suspend-lead-delivery",
);

export const unlockAgelessDashboardForDunningTest = ppost(
  "/ageless/test/platforms/{platformId}/dunning/unlock-dashboard",
);

export const unlockFreePrintsForPlatform = ppost(
  "/ageless/test/platforms/{platformId}/free-prints/unlock",
);

export const assignPlatformAdministratorRoleFromAgelessSaaSLead = ppost(
  "/ageless/test/platforms/{platformId}/leads/{agelessSaaSLeadId}/assign-platform-administrator-role",
);

export const definePersonFromAgelessSaaSLead = ppost(
  "/ageless/test/platforms/{platformId}/leads/{agelessSaaSLeadId}/define-person",
);

export const setAdminAgelessNotificationPhoneNumberForPerson = ppost(
  "/ageless/test/platforms/{platformId}/people/{personId}/admin-ageless-notification-phone-number",
);

export const mirrorRepeatMdPermissionsForAgelessPlatformPersonTestEndpoint = ppost(
  "/ageless/test/platforms/{platformId}/people/{personId}/mirror-repeatmd-permissions",
);

export const getLeadStatus = pget("/ageless/test/purchase-scenarios/leads/{leadId}/status");

export const listPlans = pget("/ageless/test/purchase-scenarios/plans");

export const purchase = ppost("/ageless/test/purchase-scenarios/purchase");

export const getPurchaseSetupOptions = pget("/ageless/test/purchase-scenarios/purchase-setup");

export const seedCancellationMetrics = ppost("/ageless/test/seed-cancellation-metrics");

export const sendAssessmentResultsE2e = ppost("/ageless/test/send-assessment-results-e2e");

export const sendAssessmentResults = ppost("/ageless/test/send-assessment-results/{assessmentId}");

export const spoofSignupE2e = ppost("/ageless/test/signup-e2e");

export const backfillDidNotConvert = ppost(
  "/ageless/test/subscriptions/{agelessSaaSSubscriptionId}/did-not-convert/backfill",
);

export const captureVisitorConsent = ppost("/ageless/visitor-consent");

export const defineAgelessWaitlistEntry = ppost("/ageless/waitlist");

export const getWaitlistEntryById = pget("/ageless/waitlist/{entryId}");

export const associatePlatformIdByWaitlistEntry = pput(
  "/ageless/waitlist/{entryId}/associated-platform-id/{platformId}",
);

export const cancelAgelessWaitlistEntry = ppost("/ageless/waitlist/{entryId}/cancel");

export const excludeAgelessWaitlistEntry = ppost("/ageless/waitlist/{entryId}/exclude");

export const setExistingRepeatMdPlatformIdForWaitlistEntry = pput(
  "/ageless/waitlist/{entryId}/existing-repeatmd-platform-id",
);

export const forceReenrollTrialCampaignForEntry = ppost(
  "/ageless/waitlist/{entryId}/force-reenroll-trial-campaign",
);

export const forceReenrollTrialConversionCampaignForEntry = ppost(
  "/ageless/waitlist/{entryId}/force-reenroll-trial-conversion-campaign",
);

export const forceReenrollWaitlistCampaignForEntry = ppost(
  "/ageless/waitlist/{entryId}/force-reenroll-waitlist-campaign",
);

export const markAgelessWaitlistEntryAsTestEntry = ppost(
  "/ageless/waitlist/{entryId}/mark-as-test-entry",
);

export const reincludeAgelessWaitlistEntry = ppost("/ageless/waitlist/{entryId}/reinclude");

export const resendReceiptForWaitlistEntry = ppost("/ageless/waitlist/{entryId}/resend-receipt");

export const uncancelAgelessWaitlistEntry = ppost("/ageless/waitlist/{entryId}/uncancel");

export const admitAgelessWaitlistEntries = ppost("/ageless/waitlist/admit");

export const admitAgelessWaitlistEntry = ppost("/ageless/waitlist/admit/{entryId}");

export const defineEnterpriseTailoredPlanSignupForPlatform = ppost("/ageless/waitlist/signup-form");

export const getWaitlistSummary = pget("/ageless/waitlist/summary");

export const getPagedWaitlistEntriesByAdmittedFoundersClubTile = pget(
  "/ageless/waitlist/tiles/admitted/founders-club",
);

export const getPagedWaitlistEntriesByAdmittedRegularTile = pget(
  "/ageless/waitlist/tiles/admitted/regular",
);

export const getPagedWaitlistEntriesByAllTile = pget("/ageless/waitlist/tiles/all");

export const getPagedWaitlistEntriesByCancelledTile = pget("/ageless/waitlist/tiles/cancelled");

export const getPagedWaitlistEntriesByExcludedTile = pget("/ageless/waitlist/tiles/excluded");

export const getPagedWaitlistEntriesByTestEntriesTile = pget(
  "/ageless/waitlist/tiles/test-entries",
);

export const getPagedWaitlistEntriesByWaitlistFoundersClubTile = pget(
  "/ageless/waitlist/tiles/waitlist/founders-club",
);

export const getPagedWaitlistEntriesByWaitlistRegularTile = pget(
  "/ageless/waitlist/tiles/waitlist/regular",
);

export const customerIoInboundWebhookProcessIncomingEmail = ppost(
  "/ageless/wellness-advisor/webhooks/customer-io/incoming-email",
);

export const customerIoInboundWebhookProcessIncomingSms = ppost(
  "/ageless/wellness-advisor/webhooks/customer-io/incoming-sms",
);

export const processPracticeComms = ppost(
  "/ageless/wellness-advisor/webhooks/customer-io/practice-comms",
);

export const processPostCall = ppost("/ageless/wellness-advisor/webhooks/elevenlabs/post-call");

export const sesInboundWebhookProcessIncomingEmail = ppost(
  "/ageless/wellness-advisor/webhooks/ses-inbound",
);

export const handleCallerIdVerificationStatusCallback = ppost(
  "/ageless/wellness-advisor/webhooks/twilio/caller-id-verification-status",
);

export const agelessTwilioWebhookProcessIncomingSms = ppost(
  "/ageless/wellness-advisor/webhooks/twilio/incoming-sms",
);

export const handleVoiceWebhook = ppost("/ageless/wellness-advisor/webhooks/twilio/voice");

export const handleVoiceStatusCallback = ppost(
  "/ageless/wellness-advisor/webhooks/twilio/voice-status",
);

export const recordWellnessDecline = ppost("/ageless/wellness-decline-backfill/{assessmentId}");

export const getPlatformGmvMonthlyTrend = pget("/analytics/{platformId}/gmv/monthly-trend");

export const getPlatformActiveMemberships = pget("/analytics/{platformId}/memberships/active");

export const getPlatformActiveMembershipGrowth = pget(
  "/analytics/{platformId}/memberships/active-membership-growth",
);

export const getPlatformActiveMembershipsByType = pget(
  "/analytics/{platformId}/memberships/active-memberships-by-type",
);

export const getPlatformAllMemberships = pget("/analytics/{platformId}/memberships/all");

export const getPlatformAnnualRecurringRevenue = pget(
  "/analytics/{platformId}/memberships/annual-recurring-revenue",
);

export const getPlatformMembershipChurn = pget("/analytics/{platformId}/memberships/churn");

export const getPlatformChurnPercentage = pget(
  "/analytics/{platformId}/memberships/churn-percentage",
);

export const getPlatformCurrentFailedPayments = pget(
  "/analytics/{platformId}/memberships/failed-payments",
);

export const getPlatformMonthlyRecurringRevenue = pget(
  "/analytics/{platformId}/memberships/monthly-recurring-revenue",
);

export const getPlatformMonthlyRecurringRevenueByMonth = pget(
  "/analytics/{platformId}/memberships/monthly-recurring-revenue-by-month",
);

export const getPlatformTopMembershipsByRevenue = pget(
  "/analytics/{platformId}/memberships/top-by-revenue",
);

export const generatePayoutReconciliationReport = ppost(
  "/analytics/{platformId}/payout-reconciliation",
);

export const getPlatformMembershipsRedeemed = pget(
  "/analytics/{platformId}/redemptions/memberships",
);

export const getPlatformOffersRedeemed = pget("/analytics/{platformId}/redemptions/offers");

export const getPlatformRedemptionCategoryAndType = pget(
  "/analytics/{platformId}/redemptions/redemption-category-and-type",
);

export const getPlatformRedemptionsByType = pget(
  "/analytics/{platformId}/redemptions/redemptions-by-type",
);

export const getPlatformRedemptionsList = pget(
  "/analytics/{platformId}/redemptions/redemptions-list",
);

export const getPlatformRedemptionsProgression = pget(
  "/analytics/{platformId}/redemptions/redemptions-progression",
);

export const getPlatformRewardsRedeemed = pget("/analytics/{platformId}/redemptions/rewards");

export const getPlatformServicesRedemption = pget("/analytics/{platformId}/redemptions/services");

export const getPlatformAverageOrderValue = pget(
  "/analytics/{platformId}/sales/average-order-value",
);

export const getPlatformSalesBreakdown = pget("/analytics/{platformId}/sales/breakdown");

export const getPlatformShopSummaryFilters = pget("/analytics/{platformId}/sales/filters");

export const getPlatformGiftCardsSales = pget("/analytics/{platformId}/sales/giftcards");

export const getPlatformMembershipsRevenue = pget(
  "/analytics/{platformId}/sales/memberships-revenue",
);

export const getPlatformMyProductSales = pget("/analytics/{platformId}/sales/myproducts");

export const getPlatformPagedListTransactionDetails = pget(
  "/analytics/{platformId}/sales/paged-list-transaction-details",
);

export const getPlatformPagedListTransactions = pget(
  "/analytics/{platformId}/sales/paged-list-transactions",
);

export const getPlatformSalesPerHour = pget("/analytics/{platformId}/sales/per-hour");

export const getPlatformSalesProgression = pget("/analytics/{platformId}/sales/progression");

export const getPlatformServicesRevenue = pget("/analytics/{platformId}/sales/services-revenue");

export const getPlatformSkinDropSales = pget("/analytics/{platformId}/sales/skindrop");

export const getPlatformTipSummary = pget("/analytics/{platformId}/sales/tips/summary");

export const getPlatformTotalSales = pget("/analytics/{platformId}/sales/total");

export const getPlatformTransactionDetails = pget(
  "/analytics/{platformId}/sales/transaction-details",
);

export const getPlatformTransactions = pget("/analytics/{platformId}/sales/transactions");

export const getPlatformAllClientsThatPurchasedServices = pget(
  "/analytics/{platformId}/services/all-clients-that-purchased-services",
);

export const getPlatformServicesAverageOrderValue = pget(
  "/analytics/{platformId}/services/average-order-value",
);

export const getPlatformOrdersCountPerOrderValue = pget(
  "/analytics/{platformId}/services/orders-count-per-order-value",
);

export const getPlatformPaymentMethodBreakdown = pget(
  "/analytics/{platformId}/services/payment-method-breakdown",
);

export const getPlatformQuantityOfPurchases = pget(
  "/analytics/{platformId}/services/quantity-of-purchases",
);

export const getPlatformTotalServicesSales = pget("/analytics/{platformId}/services/sales");

export const getPlatformSalesPerDay = pget("/analytics/{platformId}/services/sales-per-day");

export const getPlatformTotalServicesSalesProgression = pget(
  "/analytics/{platformId}/services/sales-progression",
);

export const getPlatformService = pget("/analytics/{platformId}/services/service-names");

export const getPlatformTopSellingServices = pget(
  "/analytics/{platformId}/services/top-selling-services",
);

export const getPlatformServiceTransactions = pget("/analytics/{platformId}/services/transactions");

export const getSmsMetricsHourly = pget("/analytics/{platformId}/sms-metrics/hourly");

export const getTaxReconciliationReport = pget("/analytics/{platformId}/tax-reconciliation");

export const downloadTaxReconciliationCsv = pget("/analytics/{platformId}/tax-reconciliation/csv");

export const getPlatformCompleteMemberships = pget(
  "/analytics/{platformId}/users/active-memberships",
);

export const getPlatformCompleteMembershipsByType = pget(
  "/analytics/{platformId}/users/active-memberships-by-type",
);

export const getPlatformAllClients = pget("/analytics/{platformId}/users/all");

export const getPlatformCustomerList = pget("/analytics/{platformId}/users/customer-list");

export const getPlatformNewSignups = pget("/analytics/{platformId}/users/new-signups");

export const getPlatformPagedCustomerList = pget(
  "/analytics/{platformId}/users/paged-customer-list",
);

export const getPlatformPatientsVisits = pget("/analytics/{platformId}/users/patients-visits");

export const getPlatformSignUpSourceBreakdown = pget(
  "/analytics/{platformId}/users/sign-up-source-breakdown",
);

export const getPlatformSignupsOverTime = pget("/analytics/{platformId}/users/signups-over-time");

export const getPlatformTotalVisits = pget("/analytics/{platformId}/users/visits");

export const getPlatformVisitsOverTime = pget("/analytics/{platformId}/users/visits-over-time");

export const forceFireForPlatform = ppost(
  "/analytics/practice-milestones/platform/{platformId}/{milestoneKey}/fire",
);

export const proxyAnthropicMessages = ppost("/anthropic/{platformId}/messages");

export const index = pget("/app");

export const setAssistantPatientDataSharing = pput(
  "/assistant-connections/{connectionId}/patient-data-sharing",
);

export const revokeAssistantConnection = ppost("/assistant-connections/{connectionId}/revoke");

export const revokeAssistantApplication = ppost(
  "/assistant-connections/applications/{clientId}/revoke",
);

export const exchangeToken = ppost("/auth/exchange-token");

export const login = ppost("/auth/login");

export const getAdminPermissions = pget("/auth/permissions");

export const switchPlatform = ppost("/auth/platforms/{platformId}/switch");

export const loginByEmail = ppost("/auth/request-magic-link");

export const generateRepeatMdBillingIntegrityCheck = ppost(
  "/billing-integrity/{questionCode}/generate",
);

export const retrieveActivePlatformActiveSubscriptionIntegrity = pget(
  "/billing-integrity/active-platform-active-subscription",
);

export const retrieveActivePlatformRecentNetSuiteInvoiceIntegrity = pget(
  "/billing-integrity/active-platform-recent-netsuite-invoice",
);

export const retrieveActivePlatformsMatchIntegrity = pget(
  "/billing-integrity/active-platforms-match",
);

export const retrieveActiveRmdPlatformActiveSalesforceIntegrity = pget(
  "/billing-integrity/active-rmd-platform-active-salesforce",
);

export const retrieveActiveSubscriptionActiveCompanyIntegrity = pget(
  "/billing-integrity/active-subscription-active-company",
);

export const retrieveBillingEveryPlatformIntegrity = pget(
  "/billing-integrity/billing-every-platform",
);

export const retrieveDeactivatedSalesforceActiveRmdPlatformIntegrity = pget(
  "/billing-integrity/deactivated-salesforce-active-rmd-platform",
);

export const retrieveDeactivatedSalesforceProductActivityIntegrity = pget(
  "/billing-integrity/deactivated-salesforce-product-activity",
);

export const retrieveLocationsBelowLicenseQuantityIntegrity = pget(
  "/billing-integrity/locations-below-license-quantity",
);

export const retrieveLocationsWithinLicenseQuantityIntegrity = pget(
  "/billing-integrity/locations-within-license-quantity",
);

export const retrieveNetsuiteInvoiceMatchesSalesforceIntegrity = pget(
  "/billing-integrity/netsuite-invoice-matches-salesforce",
);

export const retrievePlatformCreatedWithin30DaysIntegrity = pget(
  "/billing-integrity/platform-created-within-30-days",
);

export const retrieveSalesforceMrrSelfAgreementIntegrity = pget(
  "/billing-integrity/salesforce-mrr-self-agreement",
);

export const retrieveSalesforceStatusesMatchIntegrity = pget(
  "/billing-integrity/salesforce-statuses-match",
);

export const retrieveStalledPendingBillingSalesOrderIntegrity = pget(
  "/billing-integrity/stalled-pending-billing-sales-order",
);

export const retrieveSubscriptionMatchesNetsuiteInvoiceIntegrity = pget(
  "/billing-integrity/subscription-matches-netsuite-invoice",
);

export const retrieveSubscriptionOrderEndDateIntegrity = pget(
  "/billing-integrity/subscription-order-end-date",
);

export const retrieveSubscriptionOrderMrrIntegrity = pget(
  "/billing-integrity/subscription-order-mrr",
);

export const retrieveSubscriptionOrderStartDateIntegrity = pget(
  "/billing-integrity/subscription-order-start-date",
);

export const retrieveSummarizedRepeatMdBillingIntegrityChecks = pget("/billing-integrity/summary");

export const getPagedTransactionLedger = pget("/billing/transaction-ledger");

export const getTransactionLedgerEntry = pget("/billing/transaction-ledger/{entryId}");

export const getPagedDunningSubscriptions = pget(
  "/billing/transaction-ledger/dunning-subscriptions",
);

export const getDunningSubscriptionsCsv = pget(
  "/billing/transaction-ledger/dunning-subscriptions/csv",
);

export const getAgelessFinanceSummary = pget("/billing/transaction-ledger/finance-summary");

export const getPagedInvoicedPaidReconciliation = pget(
  "/billing/transaction-ledger/invoiced-paid-reconciliation",
);

export const getInvoicedPaidReconciliationCsv = pget(
  "/billing/transaction-ledger/invoiced-paid-reconciliation/csv",
);

export const getPagedTransactionLedgerForAgelessSaaSLead = pget(
  "/billing/transaction-ledger/leads/{agelessSaaSLeadId}",
);

export const getPagedPayments = pget("/billing/transaction-ledger/payments");

export const getPaymentsCsv = pget("/billing/transaction-ledger/payments/csv");

export const getPagedSettlementAdjustments = pget(
  "/billing/transaction-ledger/settlement-adjustments",
);

export const getSettlementAdjustmentsCsv = pget(
  "/billing/transaction-ledger/settlement-adjustments/csv",
);

export const getTransactionLedgerSummary = pget("/billing/transaction-ledger/summary");

export const dispatchForPlatform = ppost(
  "/company/monthly-summary-emails/platform/{platformId}/dispatch",
);

export const resendForPlatform = ppost(
  "/company/monthly-summary-emails/platform/{platformId}/resend",
);

export const getPagedGlobalAdministratorsForCoreServices = pget(
  "/core-services/global-administrators",
);
export const createGlobalAdministrator = ppost("/core-services/global-administrators");

export const getGlobalAdministratorForCoreServices = pget(
  "/core-services/global-administrators/{userId}",
);

export const disassociateRoleFromGlobalAdministrator = pdel(
  "/core-services/global-administrators/{userId}/roles/{role}",
);
export const associateRoleToGlobalAdministrator = ppost(
  "/core-services/global-administrators/{userId}/roles/{role}",
);

export const backfillDisputeClawback = ppost("/data-backfill/dispute-clawback");

export const applyMembershipConvenienceFee = ppost(
  "/data-backfill/platforms/{platformId}/apply-membership-convenience-fee",
);

export const defineMissingPlatformSettings = ppost(
  "/data-backfill/platforms/{platformId}/settings",
);

export const resendMembershipEvents = ppost("/data-backfill/resend-membership-events");

export const triggerStripeEventsHandling = ppost("/data-backfill/stripe-events");

export const handleSubscriptionsLastPaidInvoice = ppost(
  "/data-backfill/subscriptions-last-paid-invoice/{stripeRegion}",
);

export const getAgelessCustomerFileFields = pget("/data-dictionary/ageless-customer-file/fields");

export const getAgelessFlowTypes = pget("/data-dictionary/ageless-flow-types");

export const platformCancellationCaseBackfillUpsertCase = ppost(
  "/data-systems/platform-cancellation-cases/platforms/{platformId}/cases/backfill/upsert",
);

export const listGlobalPromotionTemplates = pget("/global-promotion-templates");
export const createGlobalPromotionTemplate = ppost("/global-promotion-templates");

export const getGlobalPromotionTemplate = pget("/global-promotion-templates/{id}");
export const updateGlobalPromotionTemplate = pput("/global-promotion-templates/{id}");

export const archiveGlobalPromotionTemplate = ppost("/global-promotion-templates/{id}/archive");

export const publishGlobalPromotionTemplate = ppost("/global-promotion-templates/{id}/publish");

export const syncPersonForNotifications = ppost("/identity/{personId}/sync");

export const optInToDfyPromotion = ppost("/incentives/{platformId}/dfy-promotions");

export const optInToGlobalPromotion = ppost("/incentives/{platformId}/global-promotions");

export const optOutOfGlobalPromotion = pdel(
  "/incentives/{platformId}/global-promotions/{globalPromotionId}",
);
export const getGlobalPromotionById = pget(
  "/incentives/{platformId}/global-promotions/{globalPromotionId}",
);
export const setGlobalPromotionConfiguration = pput(
  "/incentives/{platformId}/global-promotions/{globalPromotionId}",
);

export const retrieveActiveGlobalPromotionsForPlatform = pget(
  "/incentives/{platformId}/global-promotions/active",
);

export const retrieveArchivedGlobalPromotionsForPlatform = pget(
  "/incentives/{platformId}/global-promotions/archived",
);

export const getAvailableGlobalPromotions = pget(
  "/incentives/{platformId}/global-promotions/available",
);

export const retrieveGlobalPromotionCampaignPreviews = pget(
  "/incentives/{platformId}/global-promotions/campaign-previews",
);

export const syncCustomShopCategoryImageUrlsForGlobalPromotionsForPlatform = ppost(
  "/incentives/{platformId}/global-promotions/sync-custom-shop-categories-image-urls",
);

export const syncDescriptionForAllSpecialOffersFromTemplate = ppost(
  "/incentives/{platformId}/global-promotions/sync-special-offers-descriptions",
);

export const syncImageUrlForAllSpecialOffersFromTemplate = ppost(
  "/incentives/{platformId}/global-promotions/sync-special-offers-image-urls",
);

export const retrieveUnacknowledgedAwardedReferralRewards = pget(
  "/incentives/{platformId}/person/{personId}/unacknowledged",
);

export const retrieveIssuedWalletRewardsForPlatformUser = pget(
  "/incentives/{platformId}/platform-users/{platformUserId}/issued-wallet-rewards",
);

export const removePlatformUserReward = ppost(
  "/incentives/{platformId}/platform-users/{platformUserId}/issued-wallet-rewards/{platformUserRewardId}/remove",
);

export const restorePlatformUserReward = ppost(
  "/incentives/{platformId}/platform-users/{platformUserId}/issued-wallet-rewards/{platformUserRewardId}/restore",
);

export const getAvailableReferralRewardCampaignsForPlatform = pget(
  "/incentives/{platformId}/referral-rewards",
);
export const createReferralReward = ppost("/incentives/{platformId}/referral-rewards");

export const retrieveRedeemableAwardedReferralRewards = pget(
  "/incentives/{platformId}/referral-rewards/{personId}/redeemable",
);

export const getReferralRewardById = pget(
  "/incentives/{platformId}/referral-rewards/{referralRewardId}",
);

export const archiveReferralReward = ppost(
  "/incentives/{platformId}/referral-rewards/{referralRewardId}/archive",
);

export const setReferralRewardBonusConfiguration = pput(
  "/incentives/{platformId}/referral-rewards/{referralRewardId}/bonus-configuration",
);

export const setReferralRewardConfiguration = pput(
  "/incentives/{platformId}/referral-rewards/{referralRewardId}/configuration",
);

export const setReferralRewardDisclaimer = pput(
  "/incentives/{platformId}/referral-rewards/{referralRewardId}/disclaimer",
);

export const setReferralRewardLocations = pput(
  "/incentives/{platformId}/referral-rewards/{referralRewardId}/locations",
);

export const getArchivedReferralRewards = pget(
  "/incentives/{platformId}/referral-rewards/archived",
);

export const setAwardedReferralRewardAcknowledged = ppost(
  "/incentives/{platformId}/referral/{referralRewardId}/acknowledge/{personId}/{awardedReferralRewardId}",
);

export const getActiveSignupRewardsForPlatform = pget(
  "/incentives/{platformId}/signup-rewards/active",
);

export const getArchivedSignupRewardsForPlatform = pget(
  "/incentives/{platformId}/signup-rewards/archived",
);

export const getActiveVisitRewardsForPlatform = pget(
  "/incentives/{platformId}/visit-rewards/active",
);

export const getArchivedVisitRewardsForPlatform = pget(
  "/incentives/{platformId}/visit-rewards/archived",
);

export const refireComms = ppost(
  "/incentives/dfy-promotions/platform/{platformId}/{globalPromotionId}/comms/refire",
);

export const retrieveGiveawayPrizes = pget("/incentives/giveaway-prizes");

export const backfillGlobalPromotionOptIn = ppost(
  "/incentives/global-promotions/{globalPromotionId}/backfill",
);

export const apiKeyManagementGetApiKeys = pget("/integrations/api-keys/{platformId}");
export const apiKeyManagementCreateApiKey = ppost("/integrations/api-keys/{platformId}");

export const deleteApiKey = pdel("/integrations/api-keys/{platformId}/{apiKeySlug}");

export const refreshApiKey = ppost("/integrations/api-keys/{platformId}/{apiKeySlug}/refresh");

export const setApiKeyStatus = pput("/integrations/api-keys/{platformId}/{apiKeySlug}/status");

export const getImportPlatformFormat = pget("/integrations/import-platform-format");

export const importZenotiPlatform = ppost("/integrations/import-zenoti-platform");

export const importZenotiUsers = ppost("/integrations/import-zenoti-users");

export const getPartnerApiAccounts = pget("/integrations/partner-api-accounts");

export const getPartnerApiAccount = pget("/integrations/partner-api-accounts/{slug}");

export const createPartnerApiKey = ppost("/integrations/partner-api-accounts/{slug}/keys");

export const deletePartnerApiKey = pdel(
  "/integrations/partner-api-accounts/{slug}/keys/{apiKeySlug}",
);

export const refreshPartnerApiKey = ppost(
  "/integrations/partner-api-accounts/{slug}/keys/{apiKeySlug}/refresh",
);

export const setPartnerApiKeyStatus = pput(
  "/integrations/partner-api-accounts/{slug}/keys/{apiKeySlug}/status",
);

export const processPartnerEvent = ppost("/integrations/partner-event");

export const getPartnerInboundUpdates = pget("/integrations/partner-inbound-updates");

export const getPartnerIntegrationUpdate = pget("/integrations/partner-updates/{eventId}");

export const searchPartnerIntegrationUpdates = ppost("/integrations/partner-updates/search");

export const syncPlatformLocations = ppost(
  "/integrations/test/partner-emr-outbound-scenarios/sync-locations",
);

export const processZenotiWebhook = ppost(
  "/integrations/test/partner-emr-webhook-scenarios/process",
);

export const webhookReceive = ppost("/integrations/webhook");

export const listWebhooks = pget("/integrations/webhooks/{platformId}");
export const createWebhook = ppost("/integrations/webhooks/{platformId}");

export const deleteWebhook = pdel("/integrations/webhooks/{platformId}/{webhookId}");
export const updateWebhook = pput("/integrations/webhooks/{platformId}/{webhookId}");

export const pauseWebhook = ppost("/integrations/webhooks/{platformId}/{webhookId}/pause");

export const resumeWebhook = ppost("/integrations/webhooks/{platformId}/{webhookId}/resume");

export const testWebhook = ppost("/integrations/webhooks/{platformId}/{webhookId}/test");

export const webhookManagementGetAfterImageSample = pget(
  "/integrations/webhooks/external/after-images/sample",
);

export const getAfterImageSampleV2 = pget("/integrations/webhooks/external/after-images/sample/v2");

export const webhookManagementGetBookingRequestSample = pget(
  "/integrations/webhooks/external/booking-requests/sample",
);

export const getBookingRequestSampleV2 = pget(
  "/integrations/webhooks/external/booking-requests/sample/v2",
);

export const webhookManagementGetLashBrowImageSample = pget(
  "/integrations/webhooks/external/lash-brow-images/sample",
);

export const getLashBrowImageSampleV2 = pget(
  "/integrations/webhooks/external/lash-brow-images/sample/v2",
);

export const webhookManagementGetContactSample = pget(
  "/integrations/webhooks/external/patient-contacts/sample",
);

export const getContactSampleV2 = pget(
  "/integrations/webhooks/external/patient-contacts/sample/v2",
);

export const webhookManagementGetWellnessImageSample = pget(
  "/integrations/webhooks/external/wellness-images/sample",
);

export const getWellnessImageSampleV2 = pget(
  "/integrations/webhooks/external/wellness-images/sample/v2",
);

export const listSubscribableEvents = pget("/integrations/webhooks/subscribable-events");

export const createAnalyticsExportLink = ppost("/mcp/auth/analytics-export-links");

export const mintToken = ppost("/mcp/auth/token");

export const mintTokenForVerifiedEmail = ppost("/mcp/auth/token/mint-for-verified-email");

export const refreshToken = ppost("/mcp/auth/token/refresh");

export const verifyAssistantConnectorAccess = ppost(
  "/mcp/connectors/{clientId}/platforms/{platformId}/connections/{connectionId}/verify",
);

export const exchangeAssistantConnectorToken = ppost(
  "/mcp/connectors/{clientId}/platforms/{platformId}/exchange",
);

export const getMediaAssets = pget("/media-assets");
export const createMediaAsset = ppost("/media-assets");

export const deleteMediaAsset = pdel("/media-assets/{id}");
export const getMediaAssetById = pget("/media-assets/{id}");
export const updateMediaAsset = pput("/media-assets/{id}");

export const generateAnnotationSuggestion = ppost("/media-assets/{id}/annotation-suggestion");

export const uploadMediaAssets = ppost("/media-assets/upload");

export const replay = ppost("/memberships/renewal-replay/replay");

export const scanSubscriptionsWithoutMembership = pget(
  "/memberships/subscriptions-without-membership",
);

export const cancelSubscriptionWithoutMembership = ppost(
  "/memberships/subscriptions-without-membership/{subscriptionId}/cancel",
);

export const startPersonNotificationsForPlatformPeople = ppost(
  "/notification-sagas/platform/{platformId}/people/start",
);

export const startRepeatMdBillingIntegritySaga = ppost(
  "/notification-sagas/repeatmd-billing-integrity/start",
);

export const stopRepeatMdBillingIntegritySaga = ppost(
  "/notification-sagas/repeatmd-billing-integrity/stop",
);

export const getOpportunityBySalesforceId = pget(
  "/opportunities/by-salesforce-id/{salesforceOpportunityId}",
);

export const promote = ppost("/packages/suggested-tax-code-promotions/promote");

export const rollback = ppost("/packages/suggested-tax-code-promotions/rollback");

export const getPackageUnitTypes = pget("/packageUnitTypes");

export const setPartnerEmrForPerson = ppost("/partner-emr/person/{personId}");

export const triggerMembershipRenewal = ppost("/partner-emr/trigger-membership-renewal");

export const getPartnerCapabilityProfiles = pget("/partnerships");

export const handlePersonaWebhook = ppost("/persona/webhook");

export const getPracticeMilestoneLedgerForPlatform = pget(
  "/platform-external-traits/platforms/{platformId}/milestones/ledger",
);

export const refreshExternalTraitsForPlatform = ppost(
  "/platform-external-traits/platforms/{platformId}/refresh",
);

export const getDailyMilestoneTraitsForPlatform = pget(
  "/platform-external-traits/platforms/{platformId}/repeatmd-daily-milestones",
);

export const getRepeatMdMilestoneTraitsForPlatform = pget(
  "/platform-external-traits/platforms/{platformId}/repeatmd-milestones",
);

export const getMonthlySummaryTraitsForPlatform = pget(
  "/platform-external-traits/platforms/{platformId}/repeatmd-monthly-summary",
);

export const getRepeatMdAttributeTraitsForPlatform = pget(
  "/platform-external-traits/platforms/{platformId}/repeatmd-traits",
);

export const getByCohort = pget("/platform-insights/{cohort}");

export const getFindingPlatforms = pget(
  "/platform-insights/{cohort}/findings/{findingId}/platforms",
);

export const triggerGeneration = ppost("/platform-insights/{cohort}/generate");

export const getGenerationStatus = pget("/platform-insights/{cohort}/generation-status");

export const listCohorts = pget("/platform-insights/cohorts");

export const getCsmBriefing = pget("/platform-insights/platforms/{platformId}/csm-briefing");

export const getCsmComparablePractices = pget(
  "/platform-insights/platforms/{platformId}/csm-briefing/comparable-practices",
);

export const getCsmBriefingFeedback = pget(
  "/platform-insights/platforms/{platformId}/csm-briefing/feedback",
);
export const submitCsmBriefingFeedback = ppost(
  "/platform-insights/platforms/{platformId}/csm-briefing/feedback",
);

export const triggerCsmBriefingGeneration = ppost(
  "/platform-insights/platforms/{platformId}/csm-briefing/generate",
);

export const getCsmBriefingGeneration = pget(
  "/platform-insights/platforms/{platformId}/csm-briefing/generations/{generationId}",
);

export const getCsmBriefingGenerationPeerReferences = pget(
  "/platform-insights/platforms/{platformId}/csm-briefing/generations/{generationId}/peer-references",
);

export const getCsmPracticeOverview = pget(
  "/platform-insights/platforms/{platformId}/csm-briefing/overview",
);

export const geocode = ppost("/platform-locations/{platformLocationId}/geocode");

export const deletePlatformUser = pdel("/platform-users/{platformUserId}");

export const recalc = ppost("/platform-users/{platformUserId}/rewards/recalc");

export const platformsGetPlatforms = pget("/platforms");
export const createPlatform = ppost("/platforms");

export const platformsGetPlatform = pget("/platforms/{platformId}");
export const updatePlatform = pput("/platforms/{platformId}");

export const cancel = ppost("/platforms/{platformId}/active-memberships/cancel");

export const getAdminUsers = pget("/platforms/{platformId}/admin-users");
export const createAdminUser = ppost("/platforms/{platformId}/admin-users");

export const getAdminUser = pget("/platforms/{platformId}/admin-users/{userId}");
export const updateAdminUser = pput("/platforms/{platformId}/admin-users/{userId}");

export const updateAdminUserStatus = pput("/platforms/{platformId}/admin-users/{userId}/status");

export const definePlatformAdminUsersFromCrm = ppost(
  "/platforms/{platformId}/admin-users/from-crm",
);

export const apiKeysGetApiKeys = pget("/platforms/{platformId}/api-keys");
export const apiKeysCreateApiKey = ppost("/platforms/{platformId}/api-keys");
export const updateApiKey = pput("/platforms/{platformId}/api-keys");

export const getPartners = pget("/platforms/{platformId}/api-keys/partners");

export const authorizeAssistantConnection = ppost(
  "/platforms/{platformId}/assistant-connections/authorize",
);

export const getAssistantBrowserTestConfiguration = pget(
  "/platforms/{platformId}/assistant-connections/browser-test",
);

export const exchangeAssistantBrowserTestCode = ppost(
  "/platforms/{platformId}/assistant-connections/browser-test/exchange",
);

export const prepareNewAssistantBrowserTestConnection = ppost(
  "/platforms/{platformId}/assistant-connections/browser-test/receipts/{receiptId}/connection",
);

export const refreshAssistantBrowserTestToken = ppost(
  "/platforms/{platformId}/assistant-connections/browser-test/refresh",
);

export const linkAssistantStaffIdentity = ppost(
  "/platforms/{platformId}/assistant-connections/identity",
);

export const defineAssistantAuthorizationReceipt = ppost(
  "/platforms/{platformId}/assistant-connections/receipts",
);

export const prepareAssistantConnection = ppost(
  "/platforms/{platformId}/assistant-connections/receipts/{receiptId}/connection",
);

export const platformsAssociatePracticeTypeToPlatform = ppost(
  "/platforms/{platformId}/associate-practice-type",
);

export const platformsAssociateSalesforceAccountIdToPlatform = ppost(
  "/platforms/{platformId}/associate-salesforce-account-id",
);

export const platformsAssociateSalesforceIdToPlatform = ppost(
  "/platforms/{platformId}/associate-salesforce-id",
);

export const getAutomaticPaymentEnforcementStatus = pget(
  "/platforms/{platformId}/automatic-payment-enforcement-status",
);

export const setupBasicSmartSite = ppost("/platforms/{platformId}/basic-smart-site/setup");

export const getBillingInfoForPlatform = pget("/platforms/{platformId}/billing-info");

export const regenerateBrandIcons = ppost("/platforms/{platformId}/brand-icons/regenerate");

export const restorePreviousBrandIcons = ppost(
  "/platforms/{platformId}/brand-icons/restore-previous",
);

export const getBrandIconState = pget("/platforms/{platformId}/brand-icons/state");

export const getCallerIdVerificationInitiationDetails = pget(
  "/platforms/{platformId}/caller-id-verification/{callerIdVerificationId}",
);

export const retrieveCampaignPromotions = pget("/platforms/{platformId}/campaigns");
export const createCampaign = ppost("/platforms/{platformId}/campaigns");

export const getCampaignPromotion = pget("/platforms/{platformId}/campaigns/{campaignId}");
export const editCampaign = pput("/platforms/{platformId}/campaigns/{campaignId}");

export const archiveCampaign = ppost("/platforms/{platformId}/campaigns/{campaignId}/archive");

export const deleteCampaignDraft = pdel("/platforms/{platformId}/campaigns/{campaignId}/draft");

export const publishCampaign = ppost("/platforms/{platformId}/campaigns/{campaignId}/publish");

export const refineCampaignWithAi = ppost("/platforms/{platformId}/campaigns/{campaignId}/refine");

export const getCampaignAiSkippedOffers = pget(
  "/platforms/{platformId}/campaigns/{campaignId}/skipped-offers",
);

export const dismissCampaignAiSkippedOffers = ppost(
  "/platforms/{platformId}/campaigns/{campaignId}/skipped-offers/dismiss",
);

export const generateCampaignWithAi = ppost("/platforms/{platformId}/campaigns/generate");

export const acknowledgeCampaignAiGeneration = ppost(
  "/platforms/{platformId}/campaigns/generate/{jobId}/acknowledge",
);

export const getCampaignAiGenerationStatus = pget(
  "/platforms/{platformId}/campaigns/generate/status",
);

export const startCampaignImageGeneration = ppost(
  "/platforms/{platformId}/campaigns/images/generate",
);

export const getCampaignImageGeneration = pget(
  "/platforms/{platformId}/campaigns/images/generate/{campaignImageGenerationId}",
);

export const undoCancellationRequest = pdel("/platforms/{platformId}/cancellation-request");
export const submitCancellationRequest = ppost("/platforms/{platformId}/cancellation-request");

export const initiatePracticeCatalogDataImport = ppost("/platforms/{platformId}/catalog/import");

export const acknowledgePracticeCatalogDataImport = ppost(
  "/platforms/{platformId}/catalog/import/{importId}/acknowledge",
);

export const completePracticeCatalogDataImport = ppost(
  "/platforms/{platformId}/catalog/import/{importId}/complete",
);

export const getPracticeCatalogDataImportPreview = pget(
  "/platforms/{platformId}/catalog/import/{importId}/preview",
);

export const getPracticeCatalogDataImportStatus = pget(
  "/platforms/{platformId}/catalog/import/{importId}/status",
);

export const getLatestPracticeCatalogDataImport = pget(
  "/platforms/{platformId}/catalog/import/latest",
);

export const createMembershipFromCatalog = ppost(
  "/platforms/{platformId}/catalog/import/membership",
);

export const createPackageFromCatalog = ppost("/platforms/{platformId}/catalog/import/package");

export const createTreatmentFromCatalog = ppost("/platforms/{platformId}/catalog/import/treatment");

export const completePlgOnboarding = ppost("/platforms/{platformId}/complete-plg-onboarding");

export const confirmCustomerSuccessMeeting = ppost(
  "/platforms/{platformId}/confirm-customer-success-meeting",
);

export const confirmOnboardingBranding = ppost(
  "/platforms/{platformId}/confirm-onboarding-branding",
);

export const confirmOnboardingBusinessVerification = ppost(
  "/platforms/{platformId}/confirm-onboarding-business-verification",
);

export const confirmOnboardingCatalogUpload = ppost(
  "/platforms/{platformId}/confirm-onboarding-catalog-upload",
);

export const confirmOnboardingLocations = ppost(
  "/platforms/{platformId}/confirm-onboarding-locations",
);

export const confirmOnboardingPaymentStep = ppost(
  "/platforms/{platformId}/confirm-onboarding-payment-step",
);

export const confirmOnboardingUserInformation = ppost(
  "/platforms/{platformId}/confirm-onboarding-user-information",
);

export const categoriesGetCustomCategories = pget("/platforms/{platformId}/custom-categories");
export const createCustomCategory = ppost("/platforms/{platformId}/custom-categories");

export const deleteCustomCategory = pdel("/platforms/{platformId}/custom-categories/{categoryId}");
export const categoriesGetCustomCategoriesByCategoryId = pget(
  "/platforms/{platformId}/custom-categories/{categoryId}",
);
export const updateCustomCategory = pput("/platforms/{platformId}/custom-categories/{categoryId}");

export const createCustomCategoryPromotion = ppost(
  "/platforms/{platformId}/custom-categories/{categoryId}/promotion",
);

export const updateSiteWideOffer = pput(
  "/platforms/{platformId}/custom-categories/{categoryId}/promotion/{promotionId}",
);

export const getCustomCategoryPromotions = pget(
  "/platforms/{platformId}/custom-categories/{categoryId}/promotions",
);

export const requestCustomDomain = ppost("/platforms/{platformId}/custom-domains");

export const disableCustomDomain = pdel(
  "/platforms/{platformId}/custom-domains/{platformDomainId}",
);

export const confirmCustomDomainRouting = ppost(
  "/platforms/{platformId}/custom-domains/{platformDomainId}/confirm-routing",
);

export const deleteCustomDomain = ppost(
  "/platforms/{platformId}/custom-domains/{platformDomainId}/delete",
);

export const deployCustomDomain = ppost(
  "/platforms/{platformId}/custom-domains/{platformDomainId}/deploy",
);

export const resumeCustomDomainActivation = ppost(
  "/platforms/{platformId}/custom-domains/{platformDomainId}/resume",
);

export const verifyCustomDomain = ppost(
  "/platforms/{platformId}/custom-domains/{platformDomainId}/verify",
);

export const verifyRoutingCustomDomain = ppost(
  "/platforms/{platformId}/custom-domains/{platformDomainId}/verify-routing",
);

export const getCustomListings = pget("/platforms/{platformId}/custom-listings");

export const listForPlatform = pget("/platforms/{platformId}/custom-plans");
export const create = ppost("/platforms/{platformId}/custom-plans");

export const deletePlatformsByPlatformIdCustomPlansByCustomPlanId = pdel(
  "/platforms/{platformId}/custom-plans/{customPlanId}",
);
export const getPlatformsByPlatformIdCustomPlansByCustomPlanId = pget(
  "/platforms/{platformId}/custom-plans/{customPlanId}",
);
export const update = pput("/platforms/{platformId}/custom-plans/{customPlanId}");

export const searchCustomPlansForCommandMenu = pget(
  "/platforms/{platformId}/custom-plans/command-menu-search",
);

export const getPlatformData = pget("/platforms/{platformId}/data");

export const setDataPrivacyRegionForPlatform = pput("/platforms/{platformId}/data-privacy-region");

export const disableAutomaticPaymentEnforcementForPlatform = pput(
  "/platforms/{platformId}/disable-automatic-payment-enforcement",
);

export const disableGiftCardsForPlatform = pput("/platforms/{platformId}/disable-gift-cards");

export const disableReferralRewardsForPlatform = pput(
  "/platforms/{platformId}/disable-referral-rewards",
);

export const retrieveMapProtectedBrands = pget(
  "/platforms/{platformId}/discount-policy/map-protected-brands",
);

export const getDisputeDetails = pget("/platforms/{platformId}/dispute/{disputeId}");

export const getDisputesForPlatform = pget("/platforms/{platformId}/disputes");

export const updatePlatformDomain = pput("/platforms/{platformId}/domain");

export const getPlatformDomains = pget("/platforms/{platformId}/domains");

export const enableAutomaticPaymentEnforcementForPlatform = pput(
  "/platforms/{platformId}/enable-automatic-payment-enforcement",
);

export const enableGiftCardsForPlatform = pput("/platforms/{platformId}/enable-gift-cards");

export const enableReferralRewardsForPlatform = pput(
  "/platforms/{platformId}/enable-referral-rewards",
);

export const updatePlatformFeeConfiguration = pput("/platforms/{platformId}/fee-configuration");

export const getGenericCategory = pget("/platforms/{platformId}/generic-categories");
export const updateGenericCategory = pput("/platforms/{platformId}/generic-categories");

export const createSummerSavings2025PromotionFromTemplate = ppost(
  "/platforms/{platformId}/global-promotion-templates/summer-savings-25",
);

export const createBlackFridayVIPPreSale2025GlobalPromotionFromTemplate = ppost(
  "/platforms/{platformId}/global-promotion-templates/template/black-friday-vip-presale-25",
);

export const createFallIntoSavings2025GlobalPromotionFromTemplate = ppost(
  "/platforms/{platformId}/global-promotion-templates/template/fall-into-savings-25",
);

export const createLaborDay2025GlobalPromotionFromTemplate = ppost(
  "/platforms/{platformId}/global-promotion-templates/template/labor-day-25",
);

export const createGlobalPromotionFromTemplate = ppost(
  "/platforms/{platformId}/global-promotion-templates/template/summer-savings-25",
);

export const hideProductCatalogFromMarketplace = pput(
  "/platforms/{platformId}/hide-product-catalog-from-marketplace",
);

export const hideSkinDropFromMarketplace = pput(
  "/platforms/{platformId}/hide-skindrop-from-marketplace",
);

export const getAllowAnonLinksForPlatform = pget("/platforms/{platformId}/links");

export const getPlatformListingList = pget("/platforms/{platformId}/listings");

export const archiveListing = pput("/platforms/{platformId}/listings/{listingId}/archive");

export const getTreatmentBeforeAfterImagePairs = pget(
  "/platforms/{platformId}/listings/{listingId}/before-after-pairs",
);
export const uploadTreatmentBeforeAfterImagePair = ppost(
  "/platforms/{platformId}/listings/{listingId}/before-after-pairs",
);

export const deleteTreatmentBeforeAfterImagePair = pdel(
  "/platforms/{platformId}/listings/{listingId}/before-after-pairs/{pairId}",
);

export const setTreatmentBeforeAfterImagePairTags = pput(
  "/platforms/{platformId}/listings/{listingId}/before-after-pairs/{pairId}/tags",
);

export const deletePackageListing = pdel("/platforms/{platformId}/listings/{listingId}/draft");

export const reorderPlatformListingExpectations = pput(
  "/platforms/{platformId}/listings/{listingId}/expectations-order",
);

export const deletePlatformListingExpectation = pdel(
  "/platforms/{platformId}/listings/{listingId}/expectations/{expectationId}",
);
export const updatePlatformListingExpectation = pput(
  "/platforms/{platformId}/listings/{listingId}/expectations/{expectationId}",
);

export const updatePlatformListingPackage = pput(
  "/platforms/{platformId}/listings/{listingId}/packages",
);

export const updatePlatformListingTreatment = pput(
  "/platforms/{platformId}/listings/{listingId}/treatments",
);

export const issueUnlistedShareLinkForListing = ppost(
  "/platforms/{platformId}/listings/{listingId}/unlisted-share-link",
);

export const createPlatformListingPackage = ppost("/platforms/{platformId}/listings/packages");

export const updateActivePackageListingsOrder = pput(
  "/platforms/{platformId}/listings/packages/active/order",
);

export const createPlatformListingTreatment = ppost("/platforms/{platformId}/listings/treatments");

export const updateActiveTreatmentListingsOrder = pput(
  "/platforms/{platformId}/listings/treatments/active/order",
);

export const platformsCreatePlatformLocation = ppost("/platforms/{platformId}/locations");

export const deletePlatformLocation = pdel("/platforms/{platformId}/locations/{locationId}");
export const platformsUpdatePlatformLocation = pput(
  "/platforms/{platformId}/locations/{locationId}",
);

export const activatePlatformLocation = pput(
  "/platforms/{platformId}/locations/{locationId}/activate",
);

export const revokeCallerIdVerification = pdel(
  "/platforms/{platformId}/locations/{locationId}/caller-id-verification",
);

export const confirmCallerIdVerification = ppost(
  "/platforms/{platformId}/locations/{locationId}/caller-id-verification/confirm",
);

export const initiateCallerIdVerification = ppost(
  "/platforms/{platformId}/locations/{locationId}/caller-id-verification/initiate",
);

export const getCallerIdVerificationStatus = pget(
  "/platforms/{platformId}/locations/{locationId}/caller-id-verification/status",
);

export const deactivatePlatformLocation = pput(
  "/platforms/{platformId}/locations/{locationId}/deactivate",
);

export const getListings = pget("/platforms/{platformId}/locations/{locationId}/listings");

export const membershipsGetMemberships = pget(
  "/platforms/{platformId}/locations/{locationId}/memberships",
);

export const reorderMemberships = pput(
  "/platforms/{platformId}/locations/{locationId}/memberships-order",
);

export const getPlatformLocationOperatingHours = pget(
  "/platforms/{platformId}/locations/{locationId}/operating-hours",
);
export const setPlatformLocationOperatingHours = pput(
  "/platforms/{platformId}/locations/{locationId}/operating-hours",
);

export const getShopFeature = pget("/platforms/{platformId}/locations/{locationId}/shop-features");
export const createShopFeature = ppost(
  "/platforms/{platformId}/locations/{locationId}/shop-features",
);
export const updateShopFeature = pput(
  "/platforms/{platformId}/locations/{locationId}/shop-features",
);

export const getShopMembershipFeature = pget(
  "/platforms/{platformId}/locations/{locationId}/shop-membership-features",
);
export const updateShopMembershipFeature = ppost(
  "/platforms/{platformId}/locations/{locationId}/shop-membership-features",
);

export const deletePlatformPaymentProcessor = pdel(
  "/platforms/{platformId}/locations/{platformLocationId}/payment-processors",
);
export const createPlatformPaymentProcessor = ppost(
  "/platforms/{platformId}/locations/{platformLocationId}/payment-processors",
);
export const updatePlatformPaymentProcessor = pput(
  "/platforms/{platformId}/locations/{platformLocationId}/payment-processors",
);

export const defineAdHocPayoutForPlatform = ppost(
  "/platforms/{platformId}/locations/{platformLocationId}/payment-processors/ad-hoc-payouts",
);

export const getPlatformLocationsTimezones = pget("/platforms/{platformId}/locations/timezones");

export const getMarketingCampaigns = pget("/platforms/{platformId}/marketing-campaigns");
export const createMarketingCampaign = ppost("/platforms/{platformId}/marketing-campaigns");

export const deleteMarketingCampaign = pdel(
  "/platforms/{platformId}/marketing-campaigns/{marketingCampaignId}",
);
export const getMarketingCampaign = pget(
  "/platforms/{platformId}/marketing-campaigns/{marketingCampaignId}",
);
export const updateMarketingCampaign = pput(
  "/platforms/{platformId}/marketing-campaigns/{marketingCampaignId}",
);

export const sendMarketingCampaignTestSms = ppost(
  "/platforms/{platformId}/marketing-campaigns/sms-test",
);

export const getMarketingCampaignTextMessages = pget(
  "/platforms/{platformId}/marketing-campaigns/text-messages",
);

export const retrievePagedInvocations = pget("/platforms/{platformId}/mcp/invocations");

export const getMembershipFreezes = pget("/platforms/{platformId}/membership-freezes");

export const getPlatformMemberships = pget("/platforms/{platformId}/memberships");
export const createMembership = ppost("/platforms/{platformId}/memberships");

export const getMembershipById = pget("/platforms/{platformId}/memberships/{membershipId}");

export const updateMembership = pput(
  "/platforms/{platformId}/memberships/{membershipId}/{disableEditableValidation}",
);

export const getMembershipActiveMembers = pget(
  "/platforms/{platformId}/memberships/{membershipId}/active-members",
);

export const archiveMembership = pput("/platforms/{platformId}/memberships/{membershipId}/archive");

export const deleteMembershipDraft = pdel(
  "/platforms/{platformId}/memberships/{membershipId}/draft",
);

export const issueUnlistedShareLinkForMembership = ppost(
  "/platforms/{platformId}/memberships/{membershipId}/unlisted-share-link",
);

export const getMembershipActiveMemberCounts = pget(
  "/platforms/{platformId}/memberships/active-member-counts",
);

export const generateMemberships = ppost("/platforms/{platformId}/memberships/generate");

export const getTotalMembershipSales = pget("/platforms/{platformId}/memberships/total-sales");

export const setAdAccount = pput("/platforms/{platformId}/meta-ads/ad-account");

export const getAdAccounts = pget("/platforms/{platformId}/meta-ads/ad-accounts");

export const getMetaCampaigns = pget("/platforms/{platformId}/meta-ads/campaigns");
export const createMetaCampaign = ppost("/platforms/{platformId}/meta-ads/campaigns");

export const deleteCampaign = pdel("/platforms/{platformId}/meta-ads/campaigns/{campaignId}");

export const getCampaignAds = pget("/platforms/{platformId}/meta-ads/campaigns/{campaignId}/ads");

export const deleteAd = pdel("/platforms/{platformId}/meta-ads/campaigns/{campaignId}/ads/{adId}");

export const getAdCreative = pget(
  "/platforms/{platformId}/meta-ads/campaigns/{campaignId}/ads/{adId}/creative",
);
export const updateAdCreative = ppost(
  "/platforms/{platformId}/meta-ads/campaigns/{campaignId}/ads/{adId}/creative",
);

export const setAdStatus = ppost(
  "/platforms/{platformId}/meta-ads/campaigns/{campaignId}/ads/{adId}/status",
);

export const setCampaignBudget = ppost(
  "/platforms/{platformId}/meta-ads/campaigns/{campaignId}/budget",
);

export const changeCampaignDestination = ppost(
  "/platforms/{platformId}/meta-ads/campaigns/{campaignId}/destination",
);

export const setCampaignEndDate = ppost(
  "/platforms/{platformId}/meta-ads/campaigns/{campaignId}/end-date",
);

export const setCampaignName = ppost(
  "/platforms/{platformId}/meta-ads/campaigns/{campaignId}/name",
);

export const getMetaCampaignAdPreview = pget(
  "/platforms/{platformId}/meta-ads/campaigns/{campaignId}/preview",
);

export const setCampaignStatus = ppost(
  "/platforms/{platformId}/meta-ads/campaigns/{campaignId}/status",
);

export const setCampaignTargeting = ppost(
  "/platforms/{platformId}/meta-ads/campaigns/{campaignId}/targeting",
);

export const startConnect = pget("/platforms/{platformId}/meta-ads/connect");

export const connectDemoAccount = ppost("/platforms/{platformId}/meta-ads/connect-demo");

export const disconnect = pdel("/platforms/{platformId}/meta-ads/connection");
export const getConnection = pget("/platforms/{platformId}/meta-ads/connection");

export const reportMetaConversionTest = ppost("/platforms/{platformId}/meta-ads/conversions/test");

export const getMetaConversionTestEventCode = pget(
  "/platforms/{platformId}/meta-ads/conversions/test-event-code",
);

export const getMetaDeliveryEstimate = ppost("/platforms/{platformId}/meta-ads/delivery-estimate");

export const uploadMetaImage = ppost("/platforms/{platformId}/meta-ads/images");

export const getMetaAdsJoinableCampaigns = pget(
  "/platforms/{platformId}/meta-ads/joinable-campaigns",
);

export const getMetaLaunchPreflight = ppost("/platforms/{platformId}/meta-ads/launch-preflight");

export const getMetaLaunchPreview = ppost("/platforms/{platformId}/meta-ads/launch-preview");

export const setPage = pput("/platforms/{platformId}/meta-ads/page");

export const getPages = pget("/platforms/{platformId}/meta-ads/pages");

export const getMetaAdsPerformance = pget("/platforms/{platformId}/meta-ads/performance");

export const getReadiness = pget("/platforms/{platformId}/meta-ads/readiness");

export const syncSimulatedInsights = ppost("/platforms/{platformId}/meta-ads/sync");

export const getMetaAdsTopAssets = pget("/platforms/{platformId}/meta-ads/top-assets");

export const uploadMetaVideo = ppost("/platforms/{platformId}/meta-ads/videos");

export const getVideoStatus = pget("/platforms/{platformId}/meta-ads/videos/{videoId}/status");

export const getWizardSetup = pget("/platforms/{platformId}/meta-ads/wizard-setup");

export const getPlatformOnboardingProgress = pget("/platforms/{platformId}/onboarding-progress");

export const getPackageTreatments = pget("/platforms/{platformId}/package-treatments");

export const getDetailedPackage = pget("/platforms/{platformId}/packages/{packageId}");

export const getPlatformPaymentProcessor = pget("/platforms/{platformId}/payment-processors");

export const verifyStripeConnectAccountId = ppost(
  "/platforms/{platformId}/payment-processors/verify-stripe-connect-account-id",
);

export const platformsGetPlatformPayoutsStats = pget("/platforms/{platformId}/payouts-stats");

export const cancelPlatformPayout = ppost(
  "/platforms/{platformId}/payouts/{platformPayoutId}/cancel",
);

export const getAllStaffForPlatform = pget("/platforms/{platformId}/persons");

export const getPlatformProductSubscriptionRecord = pget(
  "/platforms/{platformId}/platform-product-subscription",
);

export const createPlatformUserPackage = ppost("/platforms/{platformId}/platform-user-packages");

export const manuallyAddPackageToPerson = ppost(
  "/platforms/{platformId}/platform-user-packages/manual",
);

export const getPlatformUsers = pget("/platforms/{platformId}/platform-users");

export const getPlatformUser = pget("/platforms/{platformId}/platform-users/{platformUserId}");
export const updatePlatformUser = pput("/platforms/{platformId}/platform-users/{platformUserId}");

export const getPlatformUserAutomatedOffers = pget(
  "/platforms/{platformId}/platform-users/{platformUserId}/automated-offers",
);

export const redeemAutomatedOffer = ppost(
  "/platforms/{platformId}/platform-users/{platformUserId}/automated-offers/redeem",
);

export const unredeemAutomatedOffer = ppost(
  "/platforms/{platformId}/platform-users/{platformUserId}/automated-offers/unredeem",
);

export const blockPlatformUser = pput(
  "/platforms/{platformId}/platform-users/{platformUserId}/block",
);

export const cancelMembership = pput(
  "/platforms/{platformId}/platform-users/{platformUserId}/cancel-membership/{platformUserMembershipId}",
);

export const getPlatformUserCart = pget(
  "/platforms/{platformId}/platform-users/{platformUserId}/cart",
);

export const addPlatformUserCartItem = ppost(
  "/platforms/{platformId}/platform-users/{platformUserId}/cart/items",
);

export const addPlatformUserCartMembership = ppost(
  "/platforms/{platformId}/platform-users/{platformUserId}/cart/memberships",
);

export const getChannelSuppressions = pget(
  "/platforms/{platformId}/platform-users/{platformUserId}/channel-suppressions",
);

export const restoreChannel = pput(
  "/platforms/{platformId}/platform-users/{platformUserId}/channel-suppressions/{channel}/restore",
);

export const suppressChannel = pput(
  "/platforms/{platformId}/platform-users/{platformUserId}/channel-suppressions/{channel}/suppress",
);

export const getPlatformUserCustomPlans = pget(
  "/platforms/{platformId}/platform-users/{platformUserId}/custom-plans",
);

export const getPlatformUserEmrLink = pget(
  "/platforms/{platformId}/platform-users/{platformUserId}/emr-link",
);
export const setPlatformUserEmrLink = pput(
  "/platforms/{platformId}/platform-users/{platformUserId}/emr-link",
);

export const adjustExternalSpend = ppost(
  "/platforms/{platformId}/platform-users/{platformUserId}/external-transaction-adjustments",
);

export const deleteExternalTransactionAdjustment = pdel(
  "/platforms/{platformId}/platform-users/{platformUserId}/external-transaction-adjustments/{adjustmentId}",
);

export const getExternalTransactions = pget(
  "/platforms/{platformId}/platform-users/{platformUserId}/external-transactions",
);

export const getPlatformUserMagicLink = pget(
  "/platforms/{platformId}/platform-users/{platformUserId}/magic-link",
);

export const getMembershipRenewalPaymentMethod = pget(
  "/platforms/{platformId}/platform-users/{platformUserId}/membership-renewals/{renewalTransactionId}/payment-method",
);

export const refundMembershipRenewal = ppost(
  "/platforms/{platformId}/platform-users/{platformUserId}/membership-renewals/{renewalTransactionId}/refund",
);

export const getMembershipRenewalRefundBenefits = pget(
  "/platforms/{platformId}/platform-users/{platformUserId}/membership-renewals/{renewalTransactionId}/refund-benefits",
);

export const previewMembershipRenewalRefund = ppost(
  "/platforms/{platformId}/platform-users/{platformUserId}/membership-renewals/{renewalTransactionId}/refund-preview",
);

export const getMembershipRenewalRefundStatus = pget(
  "/platforms/{platformId}/platform-users/{platformUserId}/membership-renewals/{renewalTransactionId}/refunds/{refundId}",
);

export const unselectMembershipTreatment = pdel(
  "/platforms/{platformId}/platform-users/{platformUserId}/membership-treatments",
);
export const getPlatformUserMembershipTreatments = pget(
  "/platforms/{platformId}/platform-users/{platformUserId}/membership-treatments",
);

export const platformUsersGetMemberships = pget(
  "/platforms/{platformId}/platform-users/{platformUserId}/memberships",
);

export const rescindMembershipChange = pdel(
  "/platforms/{platformId}/platform-users/{platformUserId}/memberships/{platformUserMembershipId}/change-membership",
);
export const scheduleMembershipChange = ppost(
  "/platforms/{platformId}/platform-users/{platformUserId}/memberships/{platformUserMembershipId}/change-membership",
);

export const getMembershipChangeOptions = pget(
  "/platforms/{platformId}/platform-users/{platformUserId}/memberships/{platformUserMembershipId}/change-options",
);

export const getMembershipFreeze = pget(
  "/platforms/{platformId}/platform-users/{platformUserId}/memberships/{platformUserMembershipId}/freeze",
);

export const createMembershipFreeze = ppost(
  "/platforms/{platformId}/platform-users/{platformUserId}/memberships/{platformUserMembershipId}/freezes",
);

export const approveMembershipFreeze = pput(
  "/platforms/{platformId}/platform-users/{platformUserId}/memberships/{platformUserMembershipId}/freezes/{membershipFreezeId}/approve",
);

export const denyMembershipFreeze = pput(
  "/platforms/{platformId}/platform-users/{platformUserId}/memberships/{platformUserMembershipId}/freezes/{membershipFreezeId}/deny",
);

export const endMembershipFreezeEarly = pput(
  "/platforms/{platformId}/platform-users/{platformUserId}/memberships/{platformUserMembershipId}/freezes/{membershipFreezeId}/end",
);

export const recreateCancelledMembershipSubscription = ppost(
  "/platforms/{platformId}/platform-users/{platformUserId}/memberships/{platformUserMembershipId}/recreate-subscription",
);

export const getPlatformUserNotes = pget(
  "/platforms/{platformId}/platform-users/{platformUserId}/notes",
);
export const addPlatformUserNote = ppost(
  "/platforms/{platformId}/platform-users/{platformUserId}/notes",
);

export const deletePlatformUserNote = pdel(
  "/platforms/{platformId}/platform-users/{platformUserId}/notes/{noteId}",
);
export const updatePlatformUserNote = pput(
  "/platforms/{platformId}/platform-users/{platformUserId}/notes/{noteId}",
);

export const platformUsersGetOrderHistory = pget(
  "/platforms/{platformId}/platform-users/{platformUserId}/order-history",
);

export const platformUsersGetOrderHistoryByOrderId = pget(
  "/platforms/{platformId}/platform-users/{platformUserId}/order-history/{orderId}",
);

export const processRefundEvent = ppost(
  "/platforms/{platformId}/platform-users/{platformUserId}/order-refund",
);

export const getOrderExternalFinancing = pget(
  "/platforms/{platformId}/platform-users/{platformUserId}/orders/{orderId}/external-financing",
);

export const processPartialRefund = ppost(
  "/platforms/{platformId}/platform-users/{platformUserId}/orders/{orderId}/partial-refund",
);

export const getRefundBreakdown = ppost(
  "/platforms/{platformId}/platform-users/{platformUserId}/orders/{orderId}/refund-breakdown",
);

export const setSalesAssociate = pput(
  "/platforms/{platformId}/platform-users/{platformUserId}/orders/{orderId}/sales-associate",
);

export const getPackages = pget("/platforms/{platformId}/platform-users/{platformUserId}/packages");

export const redeemPackageItem = ppost(
  "/platforms/{platformId}/platform-users/{platformUserId}/packages/redeem",
);

export const redeemMultipleItems = ppost(
  "/platforms/{platformId}/platform-users/{platformUserId}/packages/redeem-selected",
);

export const redeemPlatformUserPackageItemIntoRepeatCash = ppost(
  "/platforms/{platformId}/platform-users/{platformUserId}/packages/redeem/repeat-cash",
);

export const unredeemPackageItem = ppost(
  "/platforms/{platformId}/platform-users/{platformUserId}/packages/unredeem",
);

export const setPhoneNumber = pput(
  "/platforms/{platformId}/platform-users/{platformUserId}/phone-number",
);

export const changePhoneNumber = ppost(
  "/platforms/{platformId}/platform-users/{platformUserId}/phone-number-changes",
);

export const platformUsersUpdatePlatformLocation = pput(
  "/platforms/{platformId}/platform-users/{platformUserId}/platform-location",
);

export const getPlatformUserPreferences = pget(
  "/platforms/{platformId}/platform-users/{platformUserId}/preferences",
);

export const getPlatformUserRedemptions = pget(
  "/platforms/{platformId}/platform-users/{platformUserId}/redemptions",
);

export const getRepeatCashTransactionsForPersonForPlatform = pget(
  "/platforms/{platformId}/platform-users/{platformUserId}/repeat-cash-transactions",
);

export const addRepeatCashToPerson = ppost(
  "/platforms/{platformId}/platform-users/{platformUserId}/repeat-cash-transactions/add",
);

export const deductRepeatCashTransaction = ppost(
  "/platforms/{platformId}/platform-users/{platformUserId}/repeat-cash-transactions/deduct",
);

export const redeemRepeatCashFromBeautyBank = ppost(
  "/platforms/{platformId}/platform-users/{platformUserId}/repeat-cash-transactions/redeem",
);

export const getPlatformUserRewards = pget(
  "/platforms/{platformId}/platform-users/{platformUserId}/rewards",
);

export const cashIn = ppost(
  "/platforms/{platformId}/platform-users/{platformUserId}/rewards/{rewardId}/cash-in",
);

export const redeem = ppost(
  "/platforms/{platformId}/platform-users/{platformUserId}/rewards/{rewardId}/redeem",
);

export const unredeemPlatformUserReward = ppost(
  "/platforms/{platformId}/platform-users/{platformUserId}/rewards/{rewardId}/unredeem",
);

export const unredeemBankedReward = ppost(
  "/platforms/{platformId}/platform-users/{platformUserId}/rewards/{rewardId}/unredeem-banked",
);

export const getPlatformUserTags = pget(
  "/platforms/{platformId}/platform-users/{platformUserId}/tags",
);
export const addPlatformUserTag = ppost(
  "/platforms/{platformId}/platform-users/{platformUserId}/tags",
);

export const removePlatformUserTag = pdel(
  "/platforms/{platformId}/platform-users/{platformUserId}/tags/{tagId}",
);

export const getPlatformUserTransactions = pget(
  "/platforms/{platformId}/platform-users/{platformUserId}/transactions",
);

export const unblockPlatformUser = pput(
  "/platforms/{platformId}/platform-users/{platformUserId}/unblock",
);

export const verifyPlatformUser = pput(
  "/platforms/{platformId}/platform-users/{platformUserId}/verify",
);

export const getVisits = pget("/platforms/{platformId}/platform-users/{platformUserId}/visits");
export const createVisit = ppost("/platforms/{platformId}/platform-users/{platformUserId}/visits");

export const deleteVisit = pdel(
  "/platforms/{platformId}/platform-users/{platformUserId}/visits/{visitId}",
);

export const updateVisitInternalNote = pput(
  "/platforms/{platformId}/platform-users/{platformUserId}/visits/{visitId}/internal-note",
);

export const searchPlatformUsersForCommandMenu = pget(
  "/platforms/{platformId}/platform-users/command-menu-search",
);

export const trackExternalTransaction = ppost(
  "/platforms/{platformId}/platform-users/external-transactions",
);

export const startClientImport = ppost("/platforms/{platformId}/platform-users/import");

export const getClientImport = pget(
  "/platforms/{platformId}/platform-users/import/{clientImportId}",
);

export const getLatestClientImport = pget("/platforms/{platformId}/platform-users/import/latest");

export const previewClientImport = ppost("/platforms/{platformId}/platform-users/import/preview");

export const getClientsListSummary = pget("/platforms/{platformId}/platform-users/list-summary");

export const getActiveMembershipNames = pget(
  "/platforms/{platformId}/platform-users/membership-name-facets",
);

export const getPlatformUserMembershipCancellationReasons = pget(
  "/platforms/{platformId}/platform-users/membership/cancellation-reasons",
);

export const getPagedClients = pget("/platforms/{platformId}/platform-users/paged");

export const getClientTagFacets = pget("/platforms/{platformId}/platform-users/tag-facets");

export const getClientTagSuggestions = pget(
  "/platforms/{platformId}/platform-users/tag-suggestions",
);

export const getPlatformTags = pget("/platforms/{platformId}/platform-users/tags");
export const addPlatformUserTagsByPhone = ppost("/platforms/{platformId}/platform-users/tags");

export const renameClientTag = pput("/platforms/{platformId}/platform-users/tags/{tagId}");

export const mergeClientTags = ppost("/platforms/{platformId}/platform-users/tags/merge");

export const searchPatientsForVisit = pget("/platforms/{platformId}/platform-users/visit-search");

export const updatePlgOnboardingBrandingDomain = pput(
  "/platforms/{platformId}/plg-onboarding-branding-domain",
);

export const getPlgOnboardingScheduling = pget("/platforms/{platformId}/plg-onboarding-scheduling");

export const productCatalogMarketplaceVisibilitySchedule = pget(
  "/platforms/{platformId}/product-catalog-marketplace-visibility-schedule",
);

export const getAllowAnonProductSubscriptionsForPlatform = pget(
  "/platforms/{platformId}/product-subscriptions",
);

export const getPromotions = pget("/platforms/{platformId}/promotions");

export const ensureCampaignsCreated = ppost(
  "/platforms/{platformId}/promotions/{promotionId}/campaigns",
);

export const deletePromotionDraft = pdel("/platforms/{platformId}/promotions/{promotionId}/draft");

export const getAutomatedOffers = pget("/platforms/{platformId}/promotions/automated-offers");
export const createAutomatedOffer = ppost("/platforms/{platformId}/promotions/automated-offers");

export const getAutomatedOffer = pget(
  "/platforms/{platformId}/promotions/automated-offers/{promotionId}",
);
export const updateAutomatedOffer = pput(
  "/platforms/{platformId}/promotions/automated-offers/{promotionId}",
);

export const archiveAutomatedOffer = pput(
  "/platforms/{platformId}/promotions/automated-offers/{promotionId}/archive",
);

export const duplicateAutomatedOffer = ppost(
  "/platforms/{platformId}/promotions/automated-offers/{promotionId}/duplicate",
);

export const generateAutomatedOffers = ppost(
  "/platforms/{platformId}/promotions/automated-offers/generate",
);

export const acknowledgeAutomatedOfferGeneration = ppost(
  "/platforms/{platformId}/promotions/automated-offers/generate/{jobId}/acknowledge",
);

export const getAutomatedOfferGenerationStatus = pget(
  "/platforms/{platformId}/promotions/automated-offers/generate/status",
);

export const generateOfferSummary = ppost("/platforms/{platformId}/promotions/offer-summary");

export const retrieveOffersForPlatform = pget("/platforms/{platformId}/promotions/offers");

export const getSiteWideOffers = pget("/platforms/{platformId}/promotions/site-wide-offers");

export const archiveSiteWideOffer = pput(
  "/platforms/{platformId}/promotions/site-wide-offers/{promotionId}/archive",
);

export const getSpecialOffers = pget("/platforms/{platformId}/promotions/special-offers");
export const createSpecialOffer = ppost("/platforms/{platformId}/promotions/special-offers");

export const getSpecialOffer = pget(
  "/platforms/{platformId}/promotions/special-offers/{promotionId}",
);
export const updateSpecialOffer = pput(
  "/platforms/{platformId}/promotions/special-offers/{promotionId}",
);

export const archiveSpecialOffer = pput(
  "/platforms/{platformId}/promotions/special-offers/{promotionId}/archive",
);

export const duplicateSpecialOffer = ppost(
  "/platforms/{platformId}/promotions/special-offers/{promotionId}/duplicate",
);

export const setAdditionalNotes = pput("/platforms/{platformId}/properties/additional-notes");

export const setAgelessAvgPatientSpend = pput(
  "/platforms/{platformId}/properties/ageless-avg-patient-spend",
);

export const setAgelessConsultationNote = pput(
  "/platforms/{platformId}/properties/ageless-consultation-note",
);

export const setAgelessExternalBookingRedirect = pput(
  "/platforms/{platformId}/properties/ageless-external-booking-redirect",
);

export const setAgelessFullAddressCollection = pput(
  "/platforms/{platformId}/properties/ageless-full-address-collection",
);

export const setAgelessNonRepeatMdSignupRewardAmount = pput(
  "/platforms/{platformId}/properties/ageless-non-repeatmd-signup-reward-amount",
);

export const setAgelessPaybackConsultConversionRate = pput(
  "/platforms/{platformId}/properties/ageless-payback-consult-conversion-rate",
);

export const setAgelessPricingEnabled = pput(
  "/platforms/{platformId}/properties/ageless-pricing-enabled",
);

export const setAgelessRoiCloseRate = pput(
  "/platforms/{platformId}/properties/ageless-roi-close-rate",
);

export const setAgelessRoiRetentionYears = pput(
  "/platforms/{platformId}/properties/ageless-roi-retention-years",
);

export const setAgelessRoiShowRate = pput(
  "/platforms/{platformId}/properties/ageless-roi-show-rate",
);

export const setAgelessRoiVisitsPerYear = pput(
  "/platforms/{platformId}/properties/ageless-roi-visits-per-year",
);

export const setAnonymousBrowsingEnabled = pput(
  "/platforms/{platformId}/properties/anonymous-browsing-enabled",
);

export const setAnonymousCheckoutEnabled = pput(
  "/platforms/{platformId}/properties/anonymous-checkout-enabled",
);

export const setBeautifiProgram = pput("/platforms/{platformId}/properties/beautifi-program");

export const setCheckInRedemptionEnabled = pput(
  "/platforms/{platformId}/properties/check-in-redemption-enabled",
);

export const setConsultationIsFree = pput(
  "/platforms/{platformId}/properties/consultation-is-free",
);

export const getConsultationLength = pget("/platforms/{platformId}/properties/consultation-length");
export const setConsultationLength = pput("/platforms/{platformId}/properties/consultation-length");

export const disablePlgOnboarding = pput(
  "/platforms/{platformId}/properties/disable-plg-onboarding",
);

export const enablePlgOnboarding = pput("/platforms/{platformId}/properties/enable-plg-onboarding");

export const setExclusion = pput("/platforms/{platformId}/properties/exclusion");

export const setMainContact = pput("/platforms/{platformId}/properties/main-contact");

export const removePartnerIntegrationApiKey = pdel(
  "/platforms/{platformId}/properties/partner-integrations/{partnerIntegration}/api-key",
);
export const getPartnerIntegrationApiKey = pget(
  "/platforms/{platformId}/properties/partner-integrations/{partnerIntegration}/api-key",
);
export const setPartnerIntegrationApiKey = pput(
  "/platforms/{platformId}/properties/partner-integrations/{partnerIntegration}/api-key",
);

export const setPatientCheckInDisabled = pput(
  "/platforms/{platformId}/properties/patient-check-in-disabled",
);

export const setPrimaryContactEmail = pput(
  "/platforms/{platformId}/properties/primary-contact-email",
);

export const setPrimaryPhoneNumber = pput(
  "/platforms/{platformId}/properties/primary-phone-number",
);

export const setRefundRedaction = pput("/platforms/{platformId}/properties/refund-redaction");

export const setRepeatCashValue = pput("/platforms/{platformId}/properties/repeat-cash-value");

export const setShowAgelessInRepeatMdApp = pput(
  "/platforms/{platformId}/properties/show-ageless-in-repeatmd-app",
);

export const getSocialLinks = pget("/platforms/{platformId}/properties/social-links");
export const setSocialLinks = pput("/platforms/{platformId}/properties/social-links");

export const setStripeRegion = pput("/platforms/{platformId}/properties/stripe-region");

export const setTermsAndConditions = pput(
  "/platforms/{platformId}/properties/terms-and-conditions",
);

export const setTransactionFee = pput("/platforms/{platformId}/properties/transaction-fee");

export const setValuePerVisit = pput("/platforms/{platformId}/properties/value-per-visit");

export const setWebsite = pput("/platforms/{platformId}/properties/website");

export const setZenotiWebStoreMembershipPurchaseRequired = pput(
  "/platforms/{platformId}/properties/zenoti-membership-required",
);

export const setZenotiWebStoreUrl = pput("/platforms/{platformId}/properties/zenoti-web-store-url");

export const getReferralRewardCampaignsForPlatform = pget(
  "/platforms/{platformId}/referral-reward-campaigns",
);
export const createReferralRewardCampaign = ppost(
  "/platforms/{platformId}/referral-reward-campaigns",
);

export const getReferralRewardCampaign = pget(
  "/platforms/{platformId}/referral-reward-campaigns/{referralRewardCampaignId}",
);
export const updateReferralRewardCampaign = ppost(
  "/platforms/{platformId}/referral-reward-campaigns/{referralRewardCampaignId}",
);

export const activateReferralRewardCampaign = pput(
  "/platforms/{platformId}/referral-reward-campaigns/{referralRewardCampaignId}/activate",
);

export const deactivateReferralRewardCampaign = pput(
  "/platforms/{platformId}/referral-reward-campaigns/{referralRewardCampaignId}/deactivate",
);

export const updateReferralRewardCampaignDisclaimer = pput(
  "/platforms/{platformId}/referral-reward-campaigns/{referralRewardCampaignId}/disclaimer",
);

export const updateReferralRewardCampaignTitle = pput(
  "/platforms/{platformId}/referral-reward-campaigns/{referralRewardCampaignId}/title",
);

export const updateReferralRewardCampaignValidity = pput(
  "/platforms/{platformId}/referral-reward-campaigns/{referralRewardCampaignId}/validity",
);

export const getReferralRewardCampaignsForPlatformLocation = pget(
  "/platforms/{platformId}/referral-reward-campaigns/location/{locationId}",
);

export const updateReferralRewardAmount = pput(
  "/platforms/{platformId}/referral-reward-campaigns/referral-reward/{rewardId}/amount",
);

export const updateReferralRewardType = pput(
  "/platforms/{platformId}/referral-reward-campaigns/referral-reward/{rewardId}/type",
);

export const getRepeatCashTransactionsForPlatform = pget(
  "/platforms/{platformId}/repeat-cash-transactions",
);

export const getRewards = pget("/platforms/{platformId}/rewards");
export const createReward = ppost("/platforms/{platformId}/rewards");

export const updateReward = pput("/platforms/{platformId}/rewards/{rewardId}");

export const archiveReward = pput("/platforms/{platformId}/rewards/{rewardId}/archive");

export const deleteReward = pdel("/platforms/{platformId}/rewards/{rewardId}/draft");

export const checkIfRewardIsUnlocked = pget("/platforms/{platformId}/rewards/{rewardId}/unlocked");

export const checkIfRewardAppliesToUsers = ppost("/platforms/{platformId}/rewards/count-unlocked");

export const generateRewards = ppost("/platforms/{platformId}/rewards/generate");

export const acknowledgeRewardGeneration = ppost(
  "/platforms/{platformId}/rewards/generate/{jobId}/acknowledge",
);

export const getLatestRewardGeneration = pget("/platforms/{platformId}/rewards/generate/latest");

export const getSalesAssociates = pget("/platforms/{platformId}/sales-associates");
export const createSalesAssociate = ppost("/platforms/{platformId}/sales-associates");

export const updateSalesAssociate = pput(
  "/platforms/{platformId}/sales-associates/{salesAssociateId}",
);

export const scheduleProductCatalogVisibilityOnMarketplace = pput(
  "/platforms/{platformId}/schedule-product-catalog-visible-on-marketplace",
);

export const scheduleSkinDropVisibilityOnMarketplace = pput(
  "/platforms/{platformId}/schedule-skindrop-visible-on-marketplace",
);

export const claimSecondChance = ppost("/platforms/{platformId}/second-chance-claim");

export const getTotalServicesAndProceduresSales = pget(
  "/platforms/{platformId}/services-and-procedures/total-sales",
);

export const platformsSetAgelessOpportunityForPlatform = ppost(
  "/platforms/{platformId}/set-ageless-opportunity",
);

export const platformsSetRepeatMdOpportunityForPlatform = ppost(
  "/platforms/{platformId}/set-repeatmd-opportunity",
);

export const platformsSetSalesforceParentAccountIdForPlatform = ppost(
  "/platforms/{platformId}/set-salesforce-parent-account-id",
);

export const updatePlatformSettings = pput("/platforms/{platformId}/settings");

export const updatePlatformTipSettings = pput("/platforms/{platformId}/settings/tips");

export const regeneratePlatformShortLinks = ppost("/platforms/{platformId}/short-links/regenerate");

export const skinDropMarketplaceVisibilitySchedule = pget(
  "/platforms/{platformId}/skindrop-marketplace-visibility-schedule",
);

export const getPlatformSocialAccount = pget("/platforms/{platformId}/social-accounts");
export const updatePlatformSocialAccount = pput("/platforms/{platformId}/social-accounts");

export const getPlatformSponsors = pget("/platforms/{platformId}/sponsors");
export const createPlatformSponsor = ppost("/platforms/{platformId}/sponsors");

export const removePlatformSponsor = pdel("/platforms/{platformId}/sponsors/{platformSponsorId}");
export const getPlatformSponsor = pget("/platforms/{platformId}/sponsors/{platformSponsorId}");
export const updatePlatformSponsor = pput("/platforms/{platformId}/sponsors/{platformSponsorId}");

export const createPlatformSponsorAdminUser = ppost(
  "/platforms/{platformId}/sponsors/{platformSponsorId}/admins",
);

export const removePlatformSponsorAdminUser = pdel(
  "/platforms/{platformId}/sponsors/{platformSponsorId}/admins/{platformSponsorAdminUserId}",
);

export const getPlatformSponsorMembers = pget(
  "/platforms/{platformId}/sponsors/{platformSponsorId}/members",
);

export const createPlatformSponsorMembership = ppost(
  "/platforms/{platformId}/sponsors/{platformSponsorId}/memberships",
);

export const removePlatformSponsorMembership = pdel(
  "/platforms/{platformId}/sponsors/{platformSponsorId}/memberships/{platformSponsorMembershipId}",
);

export const getAssistantConnectionsForStaff = pget(
  "/platforms/{platformId}/staff/{personId}/assistant-connections",
);

export const getStripeConnectAccount = pget("/platforms/{platformId}/stripe-connect-accounts");
export const createStripeConnectAccount = ppost("/platforms/{platformId}/stripe-connect-accounts");

export const prefillStripeConnectAccountFromVerification = ppost(
  "/platforms/{platformId}/stripe-connect-accounts/{stripeAccountId}/prefill-from-verification",
);

export const createStripeConnectAccountSession = ppost(
  "/platforms/{platformId}/stripe-connect-accounts/{stripeAccountId}/sessions",
);

export const getStripeConnectAccountStatus = pget(
  "/platforms/{platformId}/stripe-connect-accounts/{stripeAccountId}/status",
);

export const getStripeConnectAccountSummary = pget(
  "/platforms/{platformId}/stripe-connect-accounts/{stripeAccountId}/summary",
);

export const syncStripeConnectAccountFromPaymentProcessors = ppost(
  "/platforms/{platformId}/stripe-connect-accounts/sync",
);

export const getSupportResolutionActionPlans = pget(
  "/platforms/{platformId}/support-resolution-actions",
);
export const createSupportResolutionActionPlan = ppost(
  "/platforms/{platformId}/support-resolution-actions",
);

export const getSupportResolutionActionPlan = pget(
  "/platforms/{platformId}/support-resolution-actions/{planId}",
);

export const updateSupportResolutionActionItem = pput(
  "/platforms/{platformId}/support-resolution-actions/{planId}/items/{itemId}",
);

export const publishSupportResolutionActionItem = ppost(
  "/platforms/{platformId}/support-resolution-actions/{planId}/items/{itemId}/publish",
);

export const rejectSupportResolutionActionItem = ppost(
  "/platforms/{platformId}/support-resolution-actions/{planId}/items/{itemId}/reject",
);

export const resolveSupportResolutionActionItemDecision = ppost(
  "/platforms/{platformId}/support-resolution-actions/{planId}/items/{itemId}/resolve-decision",
);

export const postPlatformsByPlatformIdSwitchStripeRegionByStripeRegion = ppost(
  "/platforms/{platformId}/switch-stripe-region/{stripeRegion}",
);

export const themesGetTheme = pget("/platforms/{platformId}/themes");
export const updateTheme = pput("/platforms/{platformId}/themes");

export const getThemeResources = pget("/platforms/{platformId}/themes/resources");
export const updateThemeResources = pput("/platforms/{platformId}/themes/resources");

export const getPlatformTransactionStats = pget("/platforms/{platformId}/transactions-stats");

export const getCompanyKybAccounts = pget("/platforms/{platformId}/verification-accounts");

export const getCompanyVerificationInformation = pget(
  "/platforms/{platformId}/verification-information",
);

export const getCompanyVerificationProcess = pget("/platforms/{platformId}/verification-process");

export const notifyPlatformAdminsOfPersonaKybInquiryCompleted = ppost(
  "/platforms/{platformId}/verification-process/completed-notifications",
);

export const setCompanyKybVerificationStatusForPlatform = pput(
  "/platforms/{platformId}/verification-process/status",
);

export const getVerifiedCallerIds = pget("/platforms/{platformId}/verified-caller-ids");

export const getListingAreas = pget("/platforms/areas");

export const platformsRetrieveBillingIntegrityFindings = pget(
  "/platforms/billing-reconciliation/findings",
);

export const retrieveBillingEveryPlatformIntegrityViolations = pget(
  "/platforms/billing-reconciliation/questions/billing-every-platform",
);

export const extractBranding = ppost("/platforms/branding/extract");

export const getListingConcerns = pget("/platforms/concerns");

export const getPlatformsDropdownOptions = pget("/platforms/dropdown-options");

export const getPricingTiers = pget("/platforms/pricing-tiers");

export const getPagedPlatformSummaries = pget("/platforms/summaries/paged");

export const getPagedPlatformVerificationProcesses = pget(
  "/platforms/verification-processes/paged",
);

export const createPrivateLabelMarketplace = ppost(
  "/privatelabelmarketplace/PrivateLabelMarketplace/{platformId}",
);

export const getDisplayAboutContent = pget(
  "/privatelabelmarketplace/PrivateLabelMarketplace/{subdomain}/content/about",
);

export const getDisplayHostingContent = pget(
  "/privatelabelmarketplace/PrivateLabelMarketplace/{subdomain}/content/hosting",
);

export const generateHomepageContentCopy = ppost(
  "/privatelabelmarketplace/PrivateLabelMarketplace/{subdomain}/generate/homepage",
);

export const createPrivateLabelMarketplaceForAllPlatforms = ppost(
  "/privatelabelmarketplace/PrivateLabelMarketplace/all-platforms",
);

export const getBrowseableSubdomainRoutes = pget(
  "/privatelabelmarketplace/PrivateLabelMarketplace/routing/browseable",
);

export const getSupportedLanguages = pget(
  "/privatelabelmarketplace/PrivateLabelMarketplace/supported-languages",
);

export const disableLocationTriggeredGeofencing = ppost(
  "/public/geofencing/{platformId}/disable-location-triggered-geofencing",
);

export const enableLocationTriggeredGeofencing = ppost(
  "/public/geofencing/{platformId}/enable-location-triggered-geofencing",
);

export const syncOpportunityFromSalesforce = ppost("/public/opportunities/webhooks/salesforce");

export const publicPlatformLocationsAssociateSalesforceIdToPlatform = ppost(
  "/public/platformlocations/{platformLocationId}/associate-salesforce-id",
);

export const publicPlatformLocationsGetMemberships = pget(
  "/public/platformlocations/{platformLocationId}/memberships",
);

export const setReferralRewardCopyTemplateForPlatformLocation = pput(
  "/public/platformlocations/{platformLocationId}/referral-reward-copy-template",
);

export const publicPlatformsGetPlatform = pget("/public/platforms/{platformId}");

export const associateClientExperienceManagerEmailToPlatform = ppost(
  "/public/platforms/{platformId}/associate-client-experience-manager-email",
);

export const associateClientExperienceManagerEmailAgelessAiToPlatform = ppost(
  "/public/platforms/{platformId}/associate-client-experience-manager-email-ageless-ai",
);

export const associateClientSuccessEmailToPlatform = ppost(
  "/public/platforms/{platformId}/associate-client-success-email",
);

export const associateCustomerSuccessMeetingDateTimeToPlatform = ppost(
  "/public/platforms/{platformId}/associate-customer-success-meeting-datetime",
);

export const associateCustomerSuccessMeetingLinkToPlatform = ppost(
  "/public/platforms/{platformId}/associate-customer-success-meeting-link",
);

export const associateCustomerSuccessMeetingLinkAgelessAiToPlatform = ppost(
  "/public/platforms/{platformId}/associate-customer-success-meeting-link-ageless-ai",
);

export const associateOnboardingSpecialistEmailToPlatform = ppost(
  "/public/platforms/{platformId}/associate-onboarding-specialist-email",
);

export const publicPlatformsAssociatePracticeTypeToPlatform = ppost(
  "/public/platforms/{platformId}/associate-practice-type",
);

export const publicPlatformsAssociateSalesforceAccountIdToPlatform = ppost(
  "/public/platforms/{platformId}/associate-salesforce-account-id",
);

export const publicPlatformsAssociateSalesforceIdToPlatform = ppost(
  "/public/platforms/{platformId}/associate-salesforce-id",
);

export const associateWebsiteToPlatform = ppost("/public/platforms/{platformId}/associate-website");

export const retrieveBillingReconciliationItemsForProductForPlatform = pget(
  "/public/platforms/{platformId}/billing-reconciliation",
);

export const deactivatePlatform = ppost("/public/platforms/{platformId}/deactivate");

export const publicPlatformsCreatePlatformLocation = ppost(
  "/public/platforms/{platformId}/locations",
);

export const publicPlatformsUpdatePlatformLocation = pput(
  "/public/platforms/{platformId}/locations/{locationId}",
);

export const setMarketingMessagingServiceForPlatform = ppost(
  "/public/platforms/{platformId}/marketing-messaging-service",
);

export const setMessagingServiceForPlatform = ppost(
  "/public/platforms/{platformId}/messaging-service",
);

export const setMessagingServicePhoneVerificationStatusForPlatform = ppost(
  "/public/platforms/{platformId}/messaging-service/phone-verification-status",
);

export const publicPlatformsGetPlatformPayoutsStats = pget(
  "/public/platforms/{platformId}/payouts-stats",
);

export const reactivatePlatform = ppost("/public/platforms/{platformId}/reactivate");

export const provisionRepeatMdSubscriptionForPlatform = ppost(
  "/public/platforms/{platformId}/repeatmd/subscription",
);

export const setMrrTotalsForAgelessPlatform = ppost(
  "/public/platforms/{platformId}/set-ageless-mrr-total",
);

export const publicPlatformsSetAgelessOpportunityForPlatform = ppost(
  "/public/platforms/{platformId}/set-ageless-opportunity",
);

export const setCancellationRequestForPlatform = ppost(
  "/public/platforms/{platformId}/set-cancellation-request",
);

export const setContractEndDateUtcForPlatform = ppost(
  "/public/platforms/{platformId}/set-contract-end-date-utc",
);

export const setContractStartDateUtcForPlatform = ppost(
  "/public/platforms/{platformId}/set-contract-start-date-utc",
);

export const setDeactivatedAtDateUtcForPlatform = ppost(
  "/public/platforms/{platformId}/set-deactivated-at-date-utc",
);

export const setEmrIntegrationForPlatform = ppost(
  "/public/platforms/{platformId}/set-emr-integration",
);

export const setMrrTotalsForPlatform = ppost("/public/platforms/{platformId}/set-mrr-totals");

export const setOnboardingEndDateUtcForPlatform = ppost(
  "/public/platforms/{platformId}/set-onboarding-end-date-utc",
);

export const setOnboardingStartDateUtcForPlatform = ppost(
  "/public/platforms/{platformId}/set-onboarding-start-date-utc",
);

export const setOnboardingStyleForPlatform = ppost(
  "/public/platforms/{platformId}/set-onboarding-style",
);

export const setRepeatMdChurnReasonForPlatform = ppost(
  "/public/platforms/{platformId}/set-repeatmd-churn-reason",
);

export const setRepeatMdFirstCallStatusForPlatform = ppost(
  "/public/platforms/{platformId}/set-repeatmd-first-call-status",
);

export const setMrrTotalsForRepeatMdPlatform = ppost(
  "/public/platforms/{platformId}/set-repeatmd-mrr-total",
);

export const publicPlatformsSetRepeatMdOpportunityForPlatform = ppost(
  "/public/platforms/{platformId}/set-repeatmd-opportunity",
);

export const setRepeatMdSubCancelDateForPlatform = ppost(
  "/public/platforms/{platformId}/set-repeatmd-sub-cancel-date",
);

export const setRepeatMdSubStartDateForPlatform = ppost(
  "/public/platforms/{platformId}/set-repeatmd-sub-start-date",
);

export const publicPlatformsSetSalesforceParentAccountIdForPlatform = ppost(
  "/public/platforms/{platformId}/set-salesforce-parent-account-id",
);

export const setSaveRequestStatusForPlatform = ppost(
  "/public/platforms/{platformId}/set-save-request-status",
);

export const setSupplierSponsoredForPlatform = ppost(
  "/public/platforms/{platformId}/set-supplier-sponsored",
);

export const setTotalPossibleLocationsForPlatform = ppost(
  "/public/platforms/{platformId}/set-total-possible-locations",
);

export const syncPlatformAdminsForNotifications = ppost(
  "/public/platforms/{platformId}/sync/admins",
);

export const syncPlatformAttributesForNotifications = ppost(
  "/public/platforms/{platformId}/sync/attributes",
);

export const syncPlatformClientsForNotifications = ppost(
  "/public/platforms/{platformId}/sync/clients",
);

export const syncPlatformLocationsForNotifications = ppost(
  "/public/platforms/{platformId}/sync/locations",
);

export const syncPlatformMilestonesForNotifications = ppost(
  "/public/platforms/{platformId}/sync/milestones",
);

export const syncAllPlatformMilestonesForNotifications = ppost(
  "/public/platforms/{platformId}/sync/milestones/all",
);

export const syncExtendedMilestoneTraitsForNotifications = ppost(
  "/public/platforms/{platformId}/sync/milestones/extended",
);

export const publicPlatformsGetTheme = pget("/public/platforms/{platformId}/themes");

export const retrieveAllPlatformsToBeInvoicedForProduct = pget(
  "/public/platforms/billing-reconciliation/due",
);

export const publicPlatformsRetrieveBillingIntegrityFindings = pget(
  "/public/platforms/billing-reconciliation/findings",
);

export const getAllChurnReasons = pget("/public/platforms/churn-reasons");

export const setRepeatMdSubCancelDateForSalesforceAccount = ppost(
  "/public/platforms/salesforce-accounts/{salesforceAccountId}/set-repeatmd-sub-cancel-date",
);

export const handleNetSuiteInvoicePaymentSuccess = ppost(
  "/public/platforms/webhooks/netsuite/{salesforceAccountId}/invoices/payment-success",
);

export const handleSalesforceCancellationCaseSync = ppost(
  "/public/platforms/webhooks/salesforce/cancellation-cases/{salesforceAccountId}/{salesforceCaseId}",
);

export const createPlatformFromSalesforceEvent = ppost(
  "/public/platforms/webhooks/salesforce/platform",
);

export const updatePlatformFromSalesforceEvent = ppost(
  "/public/platforms/webhooks/salesforce/platform/update",
);

export const provisionRepeatMdSubscriptionFromSalesforceEvent = ppost(
  "/public/platforms/webhooks/salesforce/repeatmd-subscription",
);

export const getXlsxForRevenueAudit = pget("/public/reports/ageless-customer-file/xlsx");

export const getRevenueByMonthForRevenueAudit = pget("/public/reports/ageless-revenue-by-month");

export const backfillCanadianTaxPayoutAllocation = ppost(
  "/purchase/canadian-tax-payout-allocations/shop-transactions/{shopTransactionId}/backfill",
);

export const previewCanadianTaxPayoutAllocationBackfill = pget(
  "/purchase/canadian-tax-payout-allocations/shop-transactions/{shopTransactionId}/preview",
);

export const verifyCanadianLegacyPayout = ppost(
  "/purchase/canadian-tax-payout-allocations/shop-transactions/{shopTransactionId}/verify-legacy-payout",
);

export const stripeDisputeStatusReconciliationReconcile = ppost(
  "/purchase/disputes/status-reconciliation",
);

export const historicalPaymentReconciliationReconcile = ppost(
  "/purchase/historical-payment-reconciliation",
);

export const reconcileTransfer = ppost("/purchase/historical-payment-reconciliation/transfer");

export const importAuthorityReport = ppost(
  "/purchase/provider-tax-line-snapshots/authority-report-import",
);

export const reconcileHistoricalOrderDiscount = ppost(
  "/purchase/provider-tax-line-snapshots/historical-order-discount-reconciliation",
);

export const importReport = ppost("/purchase/provider-tax-line-snapshots/report-import");

export const providerTaxLineSnapshotBackfillBackfill = ppost(
  "/purchase/provider-tax-line-snapshots/shop-transactions/{shopTransactionId}/backfill",
);

export const markReady = ppost(
  "/purchase/shop-display-order-post-processing/orders/{shopDisplayOrderId}/mark-ready",
);

export const transactionFeeSnapshotBackfillBackfill = ppost(
  "/purchase/transaction-fee-snapshots/{shopTransactionId}/backfill",
);

export const revoke = ppost("/purchase/v1-charge-ledger/batches/{loadBatchId}/revoke");

export const load = ppost("/purchase/v1-charge-ledger/load");

export const v1ChargeLedgerBackfillReconcile = pget("/purchase/v1-charge-ledger/reconciliation");

export const refundAllocationBackfillBackfill = ppost("/refunds/allocation-snapshots/backfill");

export const consolidateDuplicateStripeRefunds = ppost("/refunds/duplicate-cleanup/consolidate");

export const removeDuplicateStripeRefunds = ppost("/refunds/duplicate-cleanup/remove");

export const stripeRefundReconciliationBackfillBackfill = ppost(
  "/refunds/stripe-reconciliation/backfill",
);

export const reconcileLegacyCompletedStripeRefunds = ppost(
  "/refunds/stripe-reconciliation/completed-legacy",
);

export const applyHistoricalRefundRepair = ppost("/refunds/stripe-reconciliation/historical/apply");

export const previewHistoricalRefundRepair = ppost(
  "/refunds/stripe-reconciliation/historical/preview",
);

export const fillConcurrently = ppost(
  "/refunds/test/legacy-null-amount-scenarios/fill-concurrently",
);

export const seed = ppost("/refunds/test/legacy-null-amount-scenarios/seed");

export const attestedApply = ppost("/repeat-cash/beauty-bank-funding-stamps/attested-apply");

export const beautyBankFundingStampBackfillBackfill = ppost(
  "/repeat-cash/beauty-bank-funding-stamps/backfill",
);

export const feeTaxCleanup = ppost("/repeat-cash/beauty-bank-funding-stamps/fee-tax-cleanup");

export const beautyBankDoubleTax = ppost("/repeat-cash/wallet-corrections/beauty-bank-double-tax");

export const getPlgOnboardingMetrics = pget("/repeatmd-management/plg-onboarding-metrics");

export const setCaseDetails = pput(
  "/repeatmd/platform-cancellation-cases/cases/{platformCancellationCaseId}/details",
);

export const listCasesByPlatform = pget(
  "/repeatmd/platform-cancellation-cases/platforms/{platformId}/cases",
);

export const defineCase = ppost(
  "/repeatmd/platform-cancellation-cases/platforms/{platformId}/cases/backfill/define",
);

export const repeatMDCancellationCaseUpsertCase = ppost(
  "/repeatmd/platform-cancellation-cases/platforms/{platformId}/cases/backfill/upsert",
);

export const getCatalog = pget("/reports");

export const agelessCancellationsReportGetAggregates = pget(
  "/reports/ageless-cancellations/aggregates",
);

export const agelessCancellationsReportGetSnapshot = pget(
  "/reports/ageless-cancellations/snapshot",
);

export const agelessCancellationsReportGetTrend = pget("/reports/ageless-cancellations/trend");

export const getByDate = pget("/reports/ageless-customer-file");

export const getCsvByDate = pget("/reports/ageless-customer-file/csv");

export const rebuildAgelessCustomerFileSnapshotProjection = ppost(
  "/reports/ageless-customer-file/projections/ageless-customer-file-snapshot/rebuild",
);

export const getXlsxByDate = pget("/reports/ageless-customer-file/xlsx");

export const agelessLogoRetentionReportGetLogoRetentionCohort = pget(
  "/reports/ageless-logo-retention/cohort",
);

export const agelessMrrRetentionReportGetMrrRetentionCohort = pget(
  "/reports/ageless-mrr-retention/cohort",
);

export const getRevenueByMonth = pget("/reports/ageless-revenue-by-month");

export const getRevenueByMonthCsv = pget("/reports/ageless-revenue-by-month/csv");

export const getRevenueByMonthXlsx = pget("/reports/ageless-revenue-by-month/xlsx");

export const aiCallingConversionReportGetAggregates = pget(
  "/reports/ai-calling-conversion/aggregates",
);

export const aiCallingConversionReportGetPlatforms = pget(
  "/reports/ai-calling-conversion/platforms",
);

export const aiMessagingConversionReportGetAggregates = pget(
  "/reports/ai-messaging-conversion/aggregates",
);

export const aiMessagingConversionReportGetPlatforms = pget(
  "/reports/ai-messaging-conversion/platforms",
);

export const assessmentCaptureRateReportGetSnapshot = pget(
  "/reports/assessment-capture-rate/snapshot",
);

export const assessmentCaptureRateReportGetTrend = pget("/reports/assessment-capture-rate/trend");

export const assessmentConsultationConversionReportGetSnapshot = pget(
  "/reports/assessment-consultation-conversion/snapshot",
);

export const assessmentConsultationConversionReportGetTrend = pget(
  "/reports/assessment-consultation-conversion/trend",
);

export const assessmentEngagementRateReportGetSnapshot = pget(
  "/reports/assessment-engagement-rate/snapshot",
);

export const assessmentEngagementRateReportGetTrend = pget(
  "/reports/assessment-engagement-rate/trend",
);

export const getFunnel = pget("/reports/assessment-funnel/funnel");

export const assessmentFunnelReportGetTrend = pget("/reports/assessment-funnel/trend");

export const assessmentPracticeEngagementReportGetSnapshot = pget(
  "/reports/assessment-practice-engagement/snapshot",
);

export const assessmentPracticeEngagementReportGetTrend = pget(
  "/reports/assessment-practice-engagement/trend",
);

export const beautifiFinancingReportGetAggregates = pget("/reports/beautifi-financing/aggregates");

export const getCheckoutDurations = pget("/reports/beautifi-financing/checkouts");

export const getCheckoutFunnel = pget("/reports/beautifi-financing/funnel");

export const beautifiFinancingReportGetPlatforms = pget("/reports/beautifi-financing/platforms");

export const billableAssessmentsReportGetSnapshot = pget("/reports/billable-assessments/snapshot");

export const billableAssessmentsReportGetTrend = pget("/reports/billable-assessments/trend");

export const getCanadianTaxPayoutAllocationReport = pget(
  "/reports/canadian-tax-payout-allocations",
);

export const getCanadianTaxPayoutAllocationReportCsv = pget(
  "/reports/canadian-tax-payout-allocations/csv",
);

export const consultationPracticeEngagementReportGetSnapshot = pget(
  "/reports/consultation-practice-engagement/snapshot",
);

export const consultationPracticeEngagementReportGetTrend = pget(
  "/reports/consultation-practice-engagement/trend",
);

export const consultationRequestsReportGetSnapshot = pget(
  "/reports/consultation-requests/snapshot",
);

export const consultationRequestsReportGetTrend = pget("/reports/consultation-requests/trend");

export const eligibleAssessmentsReportGetSnapshot = pget("/reports/eligible-assessments/snapshot");

export const eligibleAssessmentsReportGetTrend = pget("/reports/eligible-assessments/trend");

export const getAdoption = pget("/reports/integration-adoption");

export const integrationAdoptionReportGetPlatforms = pget(
  "/reports/integration-adoption/platforms",
);

export const platformCancellationCaseGetAll = pget("/reports/platform-cancellation-cases");

export const platformCancellationCaseGetCsv = pget("/reports/platform-cancellation-cases/csv");

export const platformCancellationCaseGetXlsx = pget("/reports/platform-cancellation-cases/xlsx");

export const repeatMdCancellationsReportGetAggregates = pget(
  "/reports/repeatmd-cancellations/aggregates",
);

export const repeatMdCancellationsReportGetSnapshot = pget(
  "/reports/repeatmd-cancellations/snapshot",
);

export const repeatMdCancellationsReportGetTrend = pget("/reports/repeatmd-cancellations/trend");

export const repeatMdCustomerFileGetAll = pget("/reports/repeatmd-customer-file");

export const repeatMdCustomerFileGetCsv = pget("/reports/repeatmd-customer-file/csv");

export const getSalesforceAccountRows = pget("/reports/repeatmd-customer-file/salesforce-account");

export const getSalesforceAccountCsv = pget(
  "/reports/repeatmd-customer-file/salesforce-account/csv",
);

export const getSalesforceAccountXlsx = pget(
  "/reports/repeatmd-customer-file/salesforce-account/xlsx",
);

export const repeatMdCustomerFileGetXlsx = pget("/reports/repeatmd-customer-file/xlsx");

export const repeatMdLogoRetentionReportGetLogoRetentionCohort = pget(
  "/reports/repeatmd-logo-retention/cohort",
);

export const repeatMdMrrRetentionReportGetMrrRetentionCohort = pget(
  "/reports/repeatmd-mrr-retention/cohort",
);

export const disableShippingSubsidy = pput("/skindrop/{platformId}/disable-shipping-subsidy");

export const enableShippingSubsidy = pput("/skindrop/{platformId}/enable-shipping-subsidy");

export const retrieveCatalogFromExternalSource = pget(
  "/skindrop/{platformId}/external-source/{externalSource}/catalog",
);

export const getLaunchedSkipDropCatalogForPlatform = pget("/skindrop/{platformId}/launch");
export const launchSkipDropCatalogForPlatform = ppost("/skindrop/{platformId}/launch");

export const scheduleLaunchSkipDropCatalogForPlatform = ppost(
  "/skindrop/{platformId}/launch/{scheduleAtUtc}",
);

export const getSkinDropOnboardingProgress = pget("/skindrop/{platformId}/onboarding-progress");
export const setSkinDropOnboardingProgress = ppost("/skindrop/{platformId}/onboarding-progress");

export const getShippingSubsidy = pget("/skindrop/{platformId}/shipping-subsidy");

export const getTotalSkinDropSales = pget("/skindrop/{platformId}/total-sales");

export const retrieveExternalProductTaxClassifications = pget(
  "/skindrop/external-product-tax-classifications/{externalSourceTypeForPackage}",
);

export const previewExternalProductTaxClassifications = ppost(
  "/skindrop/external-product-tax-classifications/{externalSourceTypeForPackage}/preview",
);

export const retrieveExternalProductIdsForTaxClassification = pget(
  "/skindrop/external-product-tax-classifications/{externalSourceTypeForPackage}/product-ids",
);

export const verifyExternalProductTaxClassificationCoverage = pget(
  "/skindrop/external-product-tax-classifications/{externalSourceTypeForPackage}/verify",
);

export const cascadeAssignedTaxCodesForExternalProducts = ppost(
  "/skindrop/external-product-tax-classifications/cascade",
);

export const promoteExternalProductTaxAssignments = ppost(
  "/skindrop/external-product-tax-classifications/promote",
);

export const recordExternalProductTaxClassifications = ppost(
  "/skindrop/external-product-tax-classifications/record",
);

export const sendOrderToExternalStore = ppost(
  "/skindrop/orders/{shopDisplayOrderId}/send-to-external-store/{externalSource}",
);

export const orderFulfilledUpdate = ppost("/skindrop/skin-type-solutions/order-fulfilled");

export const createSkinTypeSolutionsProduct = ppost("/skindrop/skin-type-solutions/product-create");

export const updateSkinTypeSolutionsProduct = ppost("/skindrop/skin-type-solutions/product-update");

export const getDisplayContactContent = pget("/smartsites/{subdomain}/content/contact");

export const getDisplayHomePageContent = pget("/smartsites/{subdomain}/content/homepage");

export const getDisplayLocationsContent = pget("/smartsites/{subdomain}/content/locations");

export const getDisplayLocationContent = pget("/smartsites/{subdomain}/content/locations/{id}");

export const getDisplayTreatmentContent = pget("/smartsites/{subdomain}/content/treatment/{id}");

export const getDisplayTreatmentsContent = pget("/smartsites/{subdomain}/content/treatments");

export const submitContactForm = ppost("/smartsites/{subdomain}/forms/contact/submit");

export const submitLocationDetailForm = ppost("/smartsites/{subdomain}/forms/location/submit");

export const submitTreatmentDetailForm = ppost("/smartsites/{subdomain}/forms/treatment/submit");

export const getBrand = pget("/smartsites/{subdomain}/global/brand");

export const processStripeReplicationEvent = ppost("/stripe/replication-webhook");

export const getAvalaraTaxCodeSimulation = pget(
  "/taxonomy/{platformId}/avalara-tax-codes/simulation",
);

export const defineCustomTaxonomizedBrand = ppost("/taxonomy/{platformId}/custom-brand");

export const getAvalaraTaxCodes = pget("/taxonomy/avalara-tax-codes");

export const applyTaxCodeRecode = ppost("/taxonomy/avalara-tax-codes/recode/apply");

export const previewPackageItemTaxCodeRecode = ppost(
  "/taxonomy/avalara-tax-codes/recode/components/preview",
);

export const previewCustomPlanTaxCodeRecode = ppost(
  "/taxonomy/avalara-tax-codes/recode/custom-plans/preview",
);

export const previewDetachedPackageTaxCodes = ppost(
  "/taxonomy/avalara-tax-codes/recode/detached-packages/preview",
);

export const previewTaxCodeRecode = ppost("/taxonomy/avalara-tax-codes/recode/preview");

export const recordTaxCodeRecodeConclusions = ppost("/taxonomy/avalara-tax-codes/recode/record");

export const getBodyAreas = pget("/taxonomy/body-areas");

export const defineTaxonomizedBrand = ppost("/taxonomy/brand");

export const getCategories = pget("/taxonomy/categories");

export const setTaxonomizedCategoryProperties = pput("/taxonomy/categories/{categoryId}");

export const defineTaxonomizedCategory = ppost("/taxonomy/category");

export const getHealthConcerns = pget("/taxonomy/health-concerns");

export const getMembershipTaxComposition = pget(
  "/taxonomy/memberships/{membershipId}/tax-composition",
);

export const removeMembershipRewardFmvOverride = pdel(
  "/taxonomy/memberships/{membershipId}/tax-composition/reward/{membershipRewardId}",
);
export const setMembershipRewardFmvOverride = pput(
  "/taxonomy/memberships/{membershipId}/tax-composition/reward/{membershipRewardId}",
);

export const getPackageTaxComposition = pget("/taxonomy/packages/{packageId}/tax-composition");

export const setPackageItemTaxDetail = pput(
  "/taxonomy/packages/{packageId}/tax-composition/component",
);

export const removePackageItemTaxDetail = pdel(
  "/taxonomy/packages/{packageId}/tax-composition/component/{packageItemId}",
);

export const seedPackageTaxComposition = ppost("/taxonomy/packages/tax-composition/seed");

export const applyPackageTaxCompositionSeed = ppost(
  "/taxonomy/packages/tax-composition/seed/apply",
);

export const getSubCategories = pget("/taxonomy/subcategories");

export const setTaxonomizedSubcategoryProperties = pput("/taxonomy/subcategories/{subcategoryId}");

export const reassignCategoryForTaxonomizedSubcategory = pput(
  "/taxonomy/subcategories/{subcategoryId}/category",
);

export const defineTaxonomizedSubcategory = ppost("/taxonomy/subcategory");

export const applyMembershipRewards = ppost(
  "/taxonomy/tax-component-fmv-estimates/membership-rewards/apply",
);

export const applyPackageItems = ppost("/taxonomy/tax-component-fmv-estimates/package-items/apply");

export const preview = ppost("/taxonomy/tax-component-fmv-estimates/preview");

export const defineTaxonomizedTreatment = ppost("/taxonomy/treatment");

export const getTreatmentFamilies = pget("/taxonomy/treatment-families");
export const defineTaxonomizedTreatmentFamily = ppost("/taxonomy/treatment-families");

export const setTaxonomizedTreatmentFamilyProperties = pput(
  "/taxonomy/treatment-families/{familyId}/properties",
);

export const getTreatments = pget("/taxonomy/treatments");

export const taxonomySetTaxonomizedTreatmentProperties = pput("/taxonomy/treatments/{treatmentId}");

export const reassignFamilyForTaxonomizedTreatment = pput(
  "/taxonomy/treatments/{treatmentId}/family",
);

export const retrieveTaxonomizedTreatmentProperties = pget(
  "/taxonomy/treatments/{treatmentId}/properties",
);
export const taxonomySetTaxonomizedTreatmentPropertiesProperties = pput(
  "/taxonomy/treatments/{treatmentId}/properties",
);

export const reassignSubcategoryForTaxonomizedTreatment = pput(
  "/taxonomy/treatments/{treatmentId}/subcategory",
);

export const triggerBackfillOrderAndLineItemDiscountAmounts = ppost(
  "/test-background-jobs/backfill-discount-amounts",
);

export const triggerBirthdayOffersPromoCodeGeneration = ppost(
  "/test-background-jobs/birthday-offers",
);

export const triggerVisitRateOffersPromoCodeGeneration = ppost(
  "/test-background-jobs/visit-rate-offers",
);

export const settleOrderPayout = ppost(
  "/test/purchase-payout-scenarios/platforms/{platformId}/orders/{orderId}/settle-payout",
);

export const getDefaultThemeResources = pget("/themes/resources");

export const requestAssessmentConsentRevocation = ppost(
  "/tools/ageless-consent-revocation/assessments/{assessmentId}",
);

export const searchAssessmentsForConsentRevocation = ppost(
  "/tools/ageless-consent-revocation/search",
);

export const getCompositionDiff = pget("/tools/ageless-customer-file/composition-diff");

export const getCampaignAllowlist = pget("/tools/ageless-messaging-campaigns");

export const removeCampaign = pdel("/tools/ageless-messaging-campaigns/{campaignId}");
export const allowCampaign = pput("/tools/ageless-messaging-campaigns/{campaignId}");

export const requestSampleAssessment = ppost(
  "/tools/ageless-onboarding-sample-assessments/platforms/{platformId}/personas/{personaKey}",
);

export const setReportedSubscriptionStart = pput(
  "/tools/ageless-platforms/{platformId}/reported-subscription-start",
);

export const moveWindow = pput("/tools/ageless-saas-subscriptions/{subscriptionId}/move-window");

export const reconcilePlanFromStripe = ppost(
  "/tools/ageless-saas-subscriptions/{subscriptionId}/reconcile-plan-from-stripe",
);

export const setReportedTrialWindow = pput(
  "/tools/ageless-saas-subscriptions/{subscriptionId}/reported-trial-window",
);

export const cleanupStaleScheduledMessages = ppost(
  "/tools/ageless-scheduled-messages/cleanup-stale",
);

export const setAdmittedAt = pput("/tools/ageless-waitlist-entries/{waitlistEntryId}/admitted-at");

export const publishCategoryCatalog = ppost("/tools/categories/{categorySlug}/catalog/publish");

export const getCategoryCatalogPublishPlan = pget(
  "/tools/categories/{categorySlug}/catalog/publish-plan",
);

export const dispatch = ppost(
  "/tools/customerio-person-last-visit-backfill/platforms/{platformId}/dispatch",
);

export const purge = ppost("/tools/deactivated-platform-search-purge/platforms/{platformId}");

export const getAllCoreEvents = pget("/tools/eventsource/core-event-types");

export const getCoreEventDetails = pget("/tools/eventsource/core-event-types/{eventTypeName}");

export const getDeadLetterEvents = pget("/tools/eventsource/dead-letter-events");

export const getDeadLetterEventBuckets = pget("/tools/eventsource/dead-letter-events/buckets");

export const queuePlatformCompensationForAllPlatforms = ppost(
  "/tools/eventsource/platform-compensation/generate-all",
);

export const getEventSourceProjections = pget("/tools/eventsource/projections");

export const getProjectionDetails = pget("/tools/eventsource/projections/details");

export const getEventSourceDiagnostics = pget("/tools/eventsource/projections/diagnostics");

export const getFailedEventSourceProjections = pget("/tools/eventsource/projections/failed");

export const getFailedEventSourceProjectionCount = pget(
  "/tools/eventsource/projections/failed/count",
);

export const rebuildProjection = ppost("/tools/eventsource/projections/rebuild");

export const rebuildSingleStream = ppost("/tools/eventsource/projections/rebuild-single-stream");

export const rebuildReferralRewardsProjection = pget(
  "/tools/eventsource/projections/rebuild/referralRewards",
);

export const getCrossStoreProjectionRegistrations = pget(
  "/tools/eventsource/projections/registrations",
);

export const getEventHistoryForStreamId = pget("/tools/eventsource/streams/{streamId}/history");

export const setDestinationFlow = pput(
  "/tools/meta-ads-campaigns/{platformId}/{campaignId}/destination-flow",
);

export const debugToken = pget("/tools/meta-ads-connections/{platformId}/debug-token");

export const replaceMisHomedStripeConnectAccount = ppost(
  "/tools/mis-homed-stripe-connect-accounts/{platformId}/replacement",
);

export const disableV3ForPlatform = ppost("/tools/operations/{platformId}/disable/v3");

export const enableV3ForPlatform = ppost("/tools/operations/{platformId}/enable/v3");

export const rescoreLeadForAssessment = ppost(
  "/tools/operations/ageless/assessments/{assessmentId}/rescore-lead",
);

export const generatePlatformCompensation = ppost(
  "/tools/operations/ageless/platform-compensating",
);

export const generatePlatformCompensationForPlatform = ppost(
  "/tools/operations/ageless/platform-compensating/{platformId}",
);

export const assignTaxCodeToPackage = ppost(
  "/tools/operations/packages/{packageId}/assign-tax-code",
);

export const backfillPlatformDefinedEventForPlatform = ppost(
  "/tools/operations/platforms/{platformId}/backfill-platform-defined-event",
);

export const backfillPlgOnboardingTasksForAllPlatforms = ppost(
  "/tools/operations/plg-onboarding-tasks-backfill",
);

export const getTransactionalCommsCatalog = pget("/tools/transactional-comms");

export const setTransactionalMessageIdForKey = pput("/tools/transactional-comms/{key}");

export const sendTransactionalCommsTestEmail = ppost("/tools/transactional-comms/{key}/test-email");

export const setRetailProductSoldAtLocation = pput(
  "/unifiedretailproducts/{platformId}/{retailProductListingId}/sold-at-location",
);

export const setProductStatus = pput(
  "/unifiedretailproducts/{platformId}/{retailProductListingId}/status",
);

export const retrieveUnifiedRetailProductListing = pget(
  "/unifiedretailproducts/{platformId}/{unifiedRetailProductListing}/details",
);

export const setBodyAreaList = pput(
  "/unifiedretailproducts/{platformId}/{unifiedRetailProductListingId}/body-areas",
);

export const setBrand = pput(
  "/unifiedretailproducts/{platformId}/{unifiedRetailProductListingId}/brand",
);

export const setCategoricalProductTypeList = pput(
  "/unifiedretailproducts/{platformId}/{unifiedRetailProductListingId}/categorical-product-types",
);

export const setHealthConcernList = pput(
  "/unifiedretailproducts/{platformId}/{unifiedRetailProductListingId}/concerns",
);

export const setUnifiedRetailProductListingDescription = pput(
  "/unifiedretailproducts/{platformId}/{unifiedRetailProductListingId}/description",
);

export const setProductFeatured = pput(
  "/unifiedretailproducts/{platformId}/{unifiedRetailProductListingId}/featured",
);

export const setUnifiedRetailProductFulfillmentOptions = pput(
  "/unifiedretailproducts/{platformId}/{unifiedRetailProductListingId}/fulfillment-options",
);

export const setProductImages = pput(
  "/unifiedretailproducts/{platformId}/{unifiedRetailProductListingId}/images",
);

export const setUnifiedRetailProductIngredientsList = pput(
  "/unifiedretailproducts/{platformId}/{unifiedRetailProductListingId}/ingredients",
);

export const setRetailProductKeyBenefits = pput(
  "/unifiedretailproducts/{platformId}/{unifiedRetailProductListingId}/key-benefits",
);

export const setProductName = pput(
  "/unifiedretailproducts/{platformId}/{unifiedRetailProductListingId}/name",
);

export const setProductAssignedTaxCode = pput(
  "/unifiedretailproducts/{platformId}/{unifiedRetailProductListingId}/tax-code",
);

export const setProductUnlisted = pput(
  "/unifiedretailproducts/{platformId}/{unifiedRetailProductListingId}/unlisted",
);

export const retrieveListOfDefaultBrandsByPlatformId = pget(
  "/unifiedretailproducts/{platformId}/brands/default",
);

export const createClonedUnifiedRetailProductListing = ppost(
  "/unifiedretailproducts/{platformId}/clone-with-new-price",
);

export const disableMyProductsFreeShipping = pput(
  "/unifiedretailproducts/{platformId}/disable-myproducts-free-shipping",
);

export const disableMyProductsPickup = pput(
  "/unifiedretailproducts/{platformId}/disable-myproducts-pickup",
);

export const disableMyProductsShipping = pput(
  "/unifiedretailproducts/{platformId}/disable-myproducts-shipping",
);

export const enableMyProductsFreeShipping = pput(
  "/unifiedretailproducts/{platformId}/enable-myproducts-free-shipping",
);

export const enableMyProductsPickup = pput(
  "/unifiedretailproducts/{platformId}/enable-myproducts-pickup",
);

export const enableMyProductsShipping = pput(
  "/unifiedretailproducts/{platformId}/enable-myproducts-shipping",
);

export const retrieveExternalProductSummaries = pget(
  "/unifiedretailproducts/{platformId}/external-product-summaries",
);

export const retrieveRetailProductsFaqs = pget("/unifiedretailproducts/{platformId}/faqs");
export const setFaqsForRetailProducts = ppost("/unifiedretailproducts/{platformId}/faqs");

export const initiatePartialRetailProductRefund = ppost(
  "/unifiedretailproducts/{platformId}/initiate-partial-refund/{orderId}",
);

export const bulkCreateOrUpdateProductListings = ppost(
  "/unifiedretailproducts/{platformId}/multiple-product-listings",
);

export const setMyProductsShippingExpectations = pput(
  "/unifiedretailproducts/{platformId}/myproducts-shipping-expectations",
);

export const setMyProductsShippingRate = pput(
  "/unifiedretailproducts/{platformId}/myproducts-shipping-rate",
);

export const getMyProductsShippingSettings = pget(
  "/unifiedretailproducts/{platformId}/myproducts-shipping-settings",
);

export const retrieveOrderedRetailProduct = pget("/unifiedretailproducts/{platformId}/orders");

export const retrieveRetailProductOrderById = pget(
  "/unifiedretailproducts/{platformId}/orders/{orderId}",
);

export const markMyProductsOrderAsShipped = ppost(
  "/unifiedretailproducts/{platformId}/orders/{orderId}/mark-shipped",
);

export const redeemRetailProductOrderByAdmin = ppost(
  "/unifiedretailproducts/{platformId}/orders/{orderId}/redeem",
);

export const revertMyProductsOrderToNotShipped = ppost(
  "/unifiedretailproducts/{platformId}/orders/{orderId}/revert-to-not-shipped",
);

export const retrieveUnshippedRetailProductOrderCount = pget(
  "/unifiedretailproducts/{platformId}/orders/unshipped-count",
);

export const getRetailProductsPartialRefundSupportDetails = pget(
  "/unifiedretailproducts/{platformId}/partial-refund-details/{orderId}",
);

export const activateUnifiedRetailProductListing = ppost(
  "/unifiedretailproducts/{platformId}/product-listing/{unifiedRetailProductListingId}/activate",
);

export const deactivateUnifiedRetailProductListing = ppost(
  "/unifiedretailproducts/{platformId}/product-listing/{unifiedRetailProductListingId}/deactivate",
);

export const addUnifiedRetailProductListingVariantForExistingLocations = ppost(
  "/unifiedretailproducts/{platformId}/product-listing/add-variant",
);

export const createProductListingForSpecificLocations = ppost(
  "/unifiedretailproducts/{platformId}/product-listings",
);

export const createProductListingFromExternalSource = ppost(
  "/unifiedretailproducts/{platformId}/product-listings-from-external-source",
);

export const retrieveProductSummaries = pget(
  "/unifiedretailproducts/{platformId}/product-summaries",
);

export const retrieveRetailProductSummaryInventoryForPlatform = pget(
  "/unifiedretailproducts/{platformId}/product-summaries/inventory",
);
export const setInventoryQuantityForRetailProductVariant = pput(
  "/unifiedretailproducts/{platformId}/product-summaries/inventory",
);

export const getProductTypes = pget("/unifiedretailproducts/{platformId}/product-types");

export const retrieveRetailProductInfoForInclusionSelector = pget(
  "/unifiedretailproducts/{platformId}/product-variants-for-inclusion-selector",
);

export const getRetailProductsRefundSupportDetails = pget(
  "/unifiedretailproducts/{platformId}/refund-support-details/{orderId}",
);

export const parseRetailProductCatalog = ppost(
  "/unifiedretailproducts/{platformId}/retail-product-items/parse-catalog",
);

export const buildPayloadForParsingRetailProductCatalog = ppost(
  "/unifiedretailproducts/{platformId}/retail-product-items/payload-for-parsing",
);

export const pickUpRetailProductItems = ppost(
  "/unifiedretailproducts/{platformId}/retail-product-items/pickup",
);

export const saveRetailProductSettings = ppost("/unifiedretailproducts/{platformId}/settings");

export const getStorefrontSettings = pget(
  "/unifiedretailproducts/{platformId}/storefront-settings",
);
export const setStorefrontSettings = ppost(
  "/unifiedretailproducts/{platformId}/storefront-settings",
);

export const retrieveOrderedRetailProductForUser = pget(
  "/unifiedretailproducts/{platformId}/users/{platformUserId}/orders",
);

export const retrieveAvailableRetailProductItemsForPersonForPlatform = pget(
  "/unifiedretailproducts/{platformId}/users/{platformUserId}/retail-product-items",
);

export const undoPickupForPersonForPlatform = ppost(
  "/unifiedretailproducts/{platformId}/users/{platformUserId}/undo-pickup",
);

export const getV3OnboardingProgress = pget(
  "/unifiedretailproducts/{platformId}/v3-onboarding-progress",
);
export const setV3OnboardingProgress = ppost(
  "/unifiedretailproducts/{platformId}/v3-onboarding-progress",
);

export const setRetailProductVariantName = pput(
  "/unifiedretailproducts/{platformId}/variants/{retailProductVariantId}/name",
);

export const setRetailProductVariantPrice = pput(
  "/unifiedretailproducts/{platformId}/variants/{retailProductVariantId}/price",
);

export const setRetailProductVariantStockStatus = pput(
  "/unifiedretailproducts/{platformId}/variants/{retailProductVariantId}/status",
);

export const importRetailProductImages = ppost("/unifiedretailproducts/images/import");

export const getImageImportStatus = pget(
  "/unifiedretailproducts/images/import/{batchImportId}/status",
);

export const uploadsUploadImage = ppost("/uploads");

export const uploadMobileIcon = ppost("/uploads/mobile-icon");

export const processAcmCertificateAvailable = ppost(
  "/webhooks/custom-hostnames/aws/acm-certificate-available",
);

export const processWebhook = ppost("/webhooks/dns-automation");

export const backfillPlatformMessageActivity = ppost(
  "/wellness-advisor/communication-client-message-activity/platforms/{platformId}/backfill",
);

export const backfillPersonAttribution = ppost(
  "/wellness-advisor/sms-platform-attribution/{personId}/backfill",
);

export const appointmentGroupCreated = ppost("/zenoti/appointment-group-created");

export const appointmentGroupStatus = ppost("/zenoti/appointment-group-status");
